<template>
  <div class="SvgIconsCmp">
    <!--Logo Maserati-->
    <svg
      id="logo-maserati"
      viewBox="0 0 96 40"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleLogoMaserati contentLogoMaserati"
      role="img"
    >
      <title v-if="getString('logo-maserati', 'title')" id="titleLogoMaserati">
        {{ getString('logo-maserati', 'title') }}
      </title>
      <desc id="contentLogoMaserati">
        {{ getString('logo-maserati', 'description') }}
      </desc>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          transform="translate(0.000000, 32.000000)"
          fill="#FFFFFF"
          fill-rule="nonzero"
        >
          <path
            d="M90.9706581,2.8021048 C90.2856134,2.8024782 89.6005593,2.8027572 88.9155131,2.80303482 C88.9639038,2.71781885 89.0121885,2.63250989 89.0604621,2.54720231 C89.3955764,1.95496726 89.7478426,1.76474401 90.5103926,1.76446362 C90.8596966,1.76427762 91.2089911,1.764093 91.5581875,1.763907 C91.3624156,2.10997201 91.1665376,2.4560384 90.9706581,2.8021048 Z"
          ></path>
          <path
            d="M88.752242,6.81337513 C89.3818106,5.70185448 90.0113808,4.59023806 90.6409495,3.4787188 C89.9559048,3.47899641 89.2708507,3.47918519 88.5858045,3.47946281 C88.0424271,4.438952 87.4991462,5.39844257 86.9557688,6.35783597 C86.7721779,6.6819734 86.5211324,6.81430515 86.0894598,6.81458276 C84.4246932,6.815231 82.7599346,6.8158834 81.0951776,6.8165358 C81.7684745,5.62769462 82.4417618,4.43886038 83.1150603,3.25011776 C83.3997754,2.74783482 83.5073492,2.7119653 84.17249,2.7119653 C84.3715453,2.71186952 84.5706085,2.71177929 84.7696638,2.71177929 C85.3524249,2.71150168 85.626977,2.57396877 85.8575873,2.16666281 C85.950546,2.00226767 86.0436107,1.83778647 86.1366848,1.67339271 C85.426851,1.67367172 84.7169302,1.67404511 84.0071059,1.6744199 C84.3124602,1.13468502 84.6178225,0.595048699 84.9231863,0.0554123771 C84.4755274,0.0555983806 84.0278606,0.0557857721 83.5802016,0.0559731637 C82.9952105,0.0561591671 82.720766,0.192483054 82.4922686,0.596256333 C82.2887739,0.955891267 82.0852681,1.31552898 81.881764,1.67506674 C81.509061,1.67525552 81.136369,1.67534575 80.763666,1.67544153 C80.5677928,2.02150792 80.3719085,2.36747854 80.1760337,2.71345333 C80.548838,2.71336171 80.9216422,2.71326732 81.2944448,2.71307854 C81.0648957,3.11843285 79.4578399,5.95601573 79.2281848,6.36137004 C79.0448011,6.68513545 78.7944988,6.81718265 78.3640915,6.81746721 C76.8849466,6.81802244 75.4056862,6.81848745 73.9265365,6.81895246 C74.7129094,5.55716599 75.4993929,4.29537953 76.2857658,3.03368467 C75.7424896,3.03331544 75.1999615,3.03368467 74.6566901,3.03368467 C74.2762596,3.03359306 74.1132067,3.14231903 73.8754968,3.39193013 C73.8739137,3.11918519 73.7623149,3.03359445 73.4639462,3.03340706 C73.0873289,3.03303783 72.711137,3.0322952 72.3339899,3.03257282 C70.4799183,3.03368467 69.4438695,3.53587045 68.6386541,4.82767426 C68.3185756,5.34101608 67.9986061,5.85435234 67.6785276,6.36759838 C67.4779856,6.68950376 67.2278969,6.82080833 66.8155967,6.82080833 C65.862671,6.8210915 64.909644,6.82127473 63.9567183,6.82146073 C62.9209937,6.82173835 62.5157899,6.6908974 62.4011213,6.21445228 C62.2775581,5.70120625 62.5399275,5.28460844 63.9261185,4.47789196 C64.1876418,4.32558288 64.4492726,4.1733668 64.7109082,4.02114933 C65.0760862,3.80852655 65.2234739,3.69785032 65.1746625,3.4673823 C65.1310403,3.26136125 64.9889429,3.03414968 63.8562362,3.03424546 C62.0638956,3.03452447 60.2715487,3.03471186 58.4790959,3.0348937 C57.9102002,3.0348937 57.6451769,3.16731567 57.3880994,3.58001573 C56.8082957,4.5105092 56.2283925,5.44100544 55.6485889,6.37150029 C55.4488978,6.69173025 55.1989182,6.82238936 54.7855568,6.82238936 C51.9087815,6.82248097 49.0321139,6.82257814 46.1554462,6.82266698 C46.2782708,6.50587392 46.4010907,6.18907947 46.5238047,5.87219618 C47.9603885,5.87219618 49.3969787,5.87219618 50.8334614,5.8721004 C51.6835722,5.8721004 52.0362591,5.67908849 52.3426842,5.04568421 C52.4799009,4.76216217 52.617124,4.47863597 52.7542347,4.19511255 C52.8575747,3.98155836 52.9439747,3.67842267 52.7693749,3.44684974 C52.5662993,3.1775417 52.0452597,3.0352657 51.262594,3.03535732 C49.8832859,3.03535732 48.5038703,3.03545448 47.1244658,3.03545448 C45.8015937,3.03545448 45.1979672,3.35912273 44.7335802,4.31870353 C44.4471713,4.91056796 44.1606548,5.502524 43.8742505,6.09447866 C43.5809587,6.70065147 43.1155042,6.82247958 42.4591584,6.82247958 C41.4724523,6.82238797 40.4857558,6.82238797 39.4991605,6.82229774 C39.5612046,6.74042429 39.6232519,6.658555 39.6852977,6.5766871 C40.2709245,5.80435489 40.158478,4.94504245 39.3769763,4.21899179 C38.6095504,3.50613904 37.590875,3.25411128 36.6881381,3.03471186 C35.9208214,3.03461469 35.153503,3.03452585 34.3862969,3.03442869 C33.858482,3.88138161 33.3306639,4.7282443 32.8029533,5.57510283 C32.1425761,6.63449254 31.4250275,6.82099572 30.1590168,6.82090688 C29.2303394,6.82090688 28.3017632,6.82062788 27.3730873,6.82044049 C28.1598824,5.55818762 28.9465732,4.29593754 29.7332718,3.03368606 C29.1879855,3.03331683 28.6434409,3.03368606 28.0980502,3.03368606 C27.7176198,3.03359445 27.5545669,3.14232042 27.3168633,3.39193152 C27.3152754,3.11918658 27.203675,3.03359584 26.9053048,3.03340844 C26.5307023,3.03303921 26.1565206,3.03229659 25.7813836,3.0325742 C23.9274132,3.03368606 22.8913756,3.53587183 22.0860463,4.82767565 C21.7659693,5.34101747 21.4460014,5.85435373 21.1259213,6.36759977 C20.923899,6.6919218 20.6820692,6.81849023 20.2627864,6.81830145 C18.8475851,6.81793222 17.4324929,6.81746859 16.0172884,6.81700359 C17.2170212,4.89170665 18.4167586,2.96640694 19.6164898,1.04101839 C19.82719,0.702943204 19.5484088,0.290247311 19.1093187,0.290247311 C13.4900307,0.290247311 7.87083914,0.290247311 2.2516539,0.290247311 C1.10751262,0.290247311 0.541686722,0.544781955 -1.58154871e-06,1.35335153 C2.42942787,1.35437178 4.8587482,1.35539341 7.28817766,1.35641365 C5.93386438,3.52890642 4.57964758,5.70139364 3.22532797,7.87388224 C3.92467295,7.87388224 4.62401318,7.87388224 5.32335183,7.87388224 C6.67745792,5.70166987 8.03156402,3.52946165 9.3856717,1.35725483 C10.3585075,1.35762406 11.3313355,1.35808768 12.3041666,1.35846246 C10.9503752,3.53029728 9.59658702,5.7020391 8.24279723,7.87388224 C8.94214221,7.87388224 9.64148244,7.87388224 10.3408195,7.87388224 C11.6943974,5.70232366 13.0479721,3.53076368 14.401659,1.35920648 C15.3744886,1.35948409 16.3473165,1.35985888 17.3202567,1.3601365 C16.2029006,3.15291567 15.0854368,4.94569763 13.9680743,6.73857259 C13.8149725,6.98427484 13.6662152,7.32755119 13.827995,7.56684326 C13.9636286,7.76766455 14.3046706,7.87388224 14.8139561,7.87388224 C16.6568098,7.87388224 18.4996571,7.87388224 20.3425107,7.87388224 C20.6138807,7.87388224 20.7300312,7.79619387 20.8990181,7.61888398 C20.9001806,7.81329508 21.0860014,7.87388224 21.2981899,7.87388224 C24.4674077,7.87388224 27.6366239,7.87388224 30.8058338,7.87388224 C32.6917799,7.87388224 33.6943615,7.39018716 34.5053006,6.08918589 C34.922793,5.41926385 35.3403819,4.74934043 35.7579788,4.07932261 C35.7722681,4.08173927 35.8724339,4.0984657 35.8867232,4.10088236 C37.384834,4.35113892 38.1446273,4.83864569 38.209213,5.59117825 C38.2356834,5.89914725 38.1256804,6.17941839 37.8913661,6.40198543 C37.6118384,6.66729439 37.1823847,6.82044187 36.713019,6.82192851 C35.7553297,6.82499479 35.3715147,7.15117687 34.9992387,7.87388224 C37.6823565,7.87388224 40.3655786,7.87388224 43.048804,7.87388224 C43.3201787,7.87388224 43.4363292,7.79619387 43.6053145,7.61888398 C43.6063757,7.81329508 43.7921919,7.87388224 44.0043788,7.87388224 C47.9730963,7.87388224 51.9418185,7.87388224 55.9105376,7.87388224 C56.7138567,7.87388224 57.0620979,7.68783713 57.4631707,7.04449416 C57.9278803,6.29883678 58.3925915,5.55317108 58.8574071,4.80751232 C59.1755798,4.29714656 59.5700892,4.09827831 60.2646658,4.09827831 C60.9641089,4.09809647 61.663661,4.09800069 62.3631088,4.09790908 C62.0101024,4.31424639 61.6132681,4.5908044 61.3113995,4.8610369 C60.9132905,5.21955998 60.528941,5.7150524 60.4591647,6.35616611 C60.4104609,6.80371405 60.5352925,7.18583597 60.8203271,7.46099896 C61.1000619,7.73114124 61.5109846,7.87388224 62.0085161,7.87388224 C63.6399278,7.87388224 65.2713284,7.87388224 66.9026341,7.87388224 C67.1740041,7.87388224 67.2901546,7.79619248 67.4591399,7.61888259 C67.4602011,7.8132937 67.646128,7.87388224 67.8582042,7.87388224 C71.2910645,7.87388224 74.7239201,7.87388224 78.1567789,7.87388224 C78.4280477,7.87388224 78.5443042,7.79619248 78.7132895,7.61888259 C78.7143507,7.8132937 78.9001716,7.87388224 79.1123537,7.87388224 C84.1892181,7.87388224 89.2661868,7.87388224 94.3430606,7.87388224 C95.2605011,7.87388224 95.7260758,7.61191163 95.8995021,6.99821122 C95.9171964,6.93567102 95.9348702,6.87303644 95.9525551,6.81049902 C93.5524413,6.8115151 91.1523464,6.81244511 88.752242,6.81337513 Z M47.0306499,4.57137397 C47.2380779,4.0495801 47.718244,4.00590538 48.1516152,4.00590538 C48.9340737,4.00590538 49.7165274,4.00590538 50.4990919,4.00590538 C50.4449824,4.14548016 50.3909836,4.28496888 50.3368772,4.42445344 C50.1466122,4.91549011 49.7154694,4.95665656 49.3262503,4.95665656 C48.510021,4.95665656 47.6937821,4.95665656 46.8775481,4.95665656 C46.9285831,4.82823227 46.9796196,4.69980104 47.0306499,4.57137397 Z M25.6863009,6.10572354 C25.3618873,6.62612238 24.9808227,6.81996992 24.2790469,6.81959845 C23.8921542,6.81931891 23.5052663,6.81913846 23.1183815,6.8188539 C23.5368229,6.14763262 23.9552612,5.47631695 24.3737025,4.80509011 C24.691559,4.29500474 25.0858581,4.09614066 25.7795854,4.09614066 C26.1660463,4.09614066 26.5525135,4.09614066 26.9389744,4.09614066 C26.5213823,4.7660627 26.1037854,5.43589173 25.6863009,6.10572354 Z M72.2389071,6.10572354 C71.9144841,6.62612238 71.5333214,6.81996992 70.8316484,6.81959845 C70.4447605,6.81931891 70.0578726,6.81913846 69.6709846,6.8188539 C70.0894229,6.14763262 70.5078658,5.47631695 70.9263009,4.80509011 C71.2442665,4.29500474 71.6385671,4.09614066 72.3321837,4.09614066 C72.7186509,4.09614066 73.105115,4.09614066 73.4915775,4.09614066 C73.0739885,4.7660627 72.6563949,5.43589173 72.2389071,6.10572354 Z"
          ></path>
        </g>
        <g
          transform="translate(38.400000, 0.000000)"
          fill="#FFFFFF"
          fill-rule="nonzero"
        >
          <path
            d="M7.46580713,26.0969467 C7.46580713,25.7411318 7.46580713,25.3852624 7.46580713,25.0293946 C8.40186455,25.0293946 9.33791539,25.0293946 10.2739169,25.0293946 L10.2740271,25.0293946 C11.2100845,25.0293946 12.1461353,25.0293946 13.0821928,25.0293946 C13.0821928,25.3852624 13.0821928,25.7411334 13.0821928,26.0969467 C12.1461353,26.0969467 11.2100845,26.0969467 10.2740271,26.0969467 L10.2739169,26.0969467 C9.33791703,26.0969467 8.40186455,26.0969467 7.46580713,26.0969467 Z"
          ></path>
          <path
            d="M10.2740287,28.3081828 C10.8641744,28.3081828 11.4542642,28.3081828 12.0444133,28.3081828 C12.0444133,27.7552104 12.0444133,27.2022349 12.0444133,26.6493186 C11.4542626,26.6493186 10.8641728,26.6493186 10.2740287,26.6493186 L10.2739185,26.6493186 C9.68382874,26.6493186 9.09368302,26.6493186 8.50359322,26.6493186 C8.50359322,27.2022349 8.50359322,27.7552104 8.50359322,28.3081828 C9.09368302,28.3081828 9.68382874,28.3081828 10.2739185,28.3081828"
          ></path>
          <path
            d="M8.50359322,24.4770756 C8.49842398,23.5611241 8.25351235,22.6671023 7.50125337,22.0584547 C8.42545426,22.0584547 9.349716,22.0584547 10.2739185,22.0584547 L10.2740287,22.0584547 C11.1982905,22.0584547 12.1224914,22.0584547 13.0467482,22.0584547 C12.2944892,22.6671023 12.0495233,23.5611241 12.0444133,24.4770756 C11.4542626,24.4770756 10.8641728,24.4770756 10.2740287,24.4770756 L10.2739185,24.4770756 C9.68382874,24.4770756 9.09368302,24.4770756 8.50359322,24.4770756 Z"
          ></path>
          <path
            d="M3.81382287,20.2969381 C3.81382287,20.0342062 3.81382287,19.7715288 3.81382287,19.5087953 C5.96718535,19.5087953 8.12054948,19.5087953 10.2739185,19.5087953 L10.2740287,19.5087953 C12.4273912,19.5087953 14.5808162,19.5087953 16.7341787,19.5087953 C16.7341787,19.7715288 16.7341787,20.0342062 16.7341787,20.2969381 C14.5808162,20.2969381 12.4273912,20.2969381 10.2740287,20.2969381 L10.2739185,20.2969381 C8.12054948,20.2969381 5.96718699,20.2969381 3.81382287,20.2969381 Z"
          ></path>
          <path
            d="M4.39189167,23.1380389 C5.14617361,22.980696 5.96016419,22.5687158 6.49981151,22.0584547 C5.75092413,22.0584547 5.00209431,22.0584547 4.25320199,22.0584547 C4.29943408,22.4183161 4.34565958,22.7781791 4.39189167,23.1380389 Z"
          ></path>
          <path
            d="M16.1561099,23.1380389 C15.4018279,22.980696 14.5878374,22.5687158 14.04819,22.0584547 C14.7970774,22.0584547 15.5459138,22.0584547 16.2947995,22.0584547 C16.2485675,22.4183161 16.202342,22.7781791 16.1561099,23.1380389 Z"
          ></path>
          <path
            d="M3.59598604,17.7801484 C2.88788026,13.6968635 1.52104047,9.44518829 0.0164073733,6.64860338 C1.63141526,7.50220857 3.36742258,8.85633901 5.22442277,10.7110507 C4.4540739,10.5087516 3.68372503,10.3499307 2.91338273,10.2345337 C3.9873963,12.7070812 4.87469211,15.2308157 5.68126845,17.7801484 C4.9861935,17.7801484 4.29106099,17.7801484 3.59598604,17.7801484 Z"
          ></path>
          <path
            d="M16.9519612,17.7801484 C17.660067,13.6968635 19.0269101,9.44518829 20.5315399,6.64860338 C18.9165287,7.50220857 17.1805247,8.85633901 15.3235245,10.7110507 C16.0938734,10.5087516 16.8642222,10.3499307 17.6345645,10.2345337 C16.560551,12.7070812 15.6732552,15.2308157 14.8666788,17.7801484 C15.5617538,17.7801484 16.2568846,17.7801484 16.9519612,17.7801484 Z"
          ></path>
          <path
            d="M3.12891536,19.0979071 C3.12891536,18.8317837 3.12891536,18.5657164 3.12891536,18.2995929 C5.51061598,18.2995929 7.89226726,18.2995929 10.2739169,18.2995929 L10.2740271,18.2995929 C12.6557326,18.2995929 15.0373839,18.2995929 17.4190286,18.2995929 C17.4190286,18.5657164 17.4190286,18.8317837 17.4190286,19.0979071 C15.0373823,19.0979071 12.6557326,19.0979071 10.2740271,19.0979071 L10.2739169,19.0979071 C7.89226726,19.0979071 5.51061762,19.0979071 3.12891536,19.0979071 Z"
          ></path>
          <path
            d="M7.8660921,6.21704254 C8.9692577,4.3688961 9.91604504,2.26813314 10.2739728,0.0921190896 C10.6319006,2.26813474 11.5787438,4.3688961 12.6818535,6.21704254 C12.2890979,6.0443849 11.8728628,5.86237732 11.4118001,5.6630854 C11.0124691,5.49048381 10.8427162,5.59231633 10.856252,5.99303149 C10.9890438,9.91831544 11.581775,14.381313 13.6859894,17.7801468 C12.8596916,17.7801468 12.0334547,17.7801468 11.2071619,17.7801468 C10.8188437,16.875952 10.5078141,15.9835171 10.2739712,15.102895 C10.0401825,15.9835171 9.72909868,16.875952 9.34078043,17.7801468 C8.51454353,17.7801468 7.68824578,17.7801468 6.86200888,17.7801468 C8.96616898,14.3813114 9.55895442,9.91831544 9.69169198,5.99303149 C9.70528365,5.59231633 9.5354749,5.49048381 9.13614384,5.6630854 C8.67513876,5.86237732 8.25890363,6.0443849 7.8660921,6.21704254 Z"
          ></path>
          <path
            d="M3.12891536,21.5061373 C3.12891536,21.2400138 3.12891536,20.9739481 3.12891536,20.7078247 C5.51061598,20.7078247 7.89226726,20.7078247 10.2739169,20.7078247 L10.2740271,20.7078247 C12.6557326,20.7078247 15.0373839,20.7078247 17.4190286,20.7078247 C17.4190286,20.9739481 17.4190286,21.2400138 17.4190286,21.5061373 C15.0373823,21.5061373 12.6557326,21.5061373 10.2740271,21.5061373 L10.2739169,21.5061373 C7.89226726,21.5061373 5.51061762,21.5061373 3.12891536,21.5061373 Z"
          ></path>
        </g>
      </g>
    </svg>
    <!-- Logo Stellantis -->
    <svg
      id="logo-stellantis"
      viewBox="0 0 286 95"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleLogoStellantis contentLogoStellantis"
      role="img"
    >
      <title
        v-if="getString('logo-stellantis', 'title')"
        id="titleLogoStellantis"
      >
        {{ getString('logo-stellantis', 'title') }}
      </title>
      <desc id="contentLogoStellantis">
        {{ getString('logo-stellantis', 'description') }}
      </desc>
      <g>
        <path
          d="M4.694,8.98h6a9.461,9.461,0,0,1,3.452.439,3.79,3.79,0,0,1,1.682,1.551,4.685,4.685,0,0,1,.686,2.514,4.683,4.683,0,0,1-.588,2.337A3.817,3.817,0,0,1,14.4,17.367a4.032,4.032,0,0,1,2.083,1.585,4.8,4.8,0,0,1,.752,2.735,5.554,5.554,0,0,1-.959,3.3,3.929,3.929,0,0,1-2.266,1.667,24.02,24.02,0,0,1-4.22.219H4.694Zm3.013,2.978V16.1H9.7q1.793,0,2.216-.06a1.9,1.9,0,0,0,1.208-.642,2.12,2.12,0,0,0,.436-1.409A2.153,2.153,0,0,0,13.2,12.7a1.472,1.472,0,0,0-.859-.616,18.605,18.605,0,0,0-2.895-.123Zm0,7.117v4.773h2.807a8.968,8.968,0,0,0,2.37-.189,1.767,1.767,0,0,0,.879-.743,2.946,2.946,0,0,0-.026-2.849,1.935,1.935,0,0,0-1.009-.779,9.776,9.776,0,0,0-2.577-.213Z"
          transform="translate(2.016 3.856)"
        />
        <path
          d="M42.594,26.874H39.319l-1.312-4.052H32.016l-1.236,4.052H27.566L33.4,8.979h3.2Zm-5.559-7.08-2.067-6.64-2.027,6.64Z"
          transform="translate(11.838 3.856)"
        />
        <path
          d="M52.59,26.874V8.98h2.939l6.125,11.95V8.98h2.813V26.874H61.429L55.4,15.205V26.874Z"
          transform="translate(22.584 3.856)"
        />
        <path
          d="M86.242,20.387,89.168,21.5a8,8,0,0,1-2.279,4.388,5.768,5.768,0,0,1-3.922,1.385,5.849,5.849,0,0,1-4.743-2.21,10.526,10.526,0,0,1-2.091-6.884,11.045,11.045,0,0,1,2.106-7.164,6.02,6.02,0,0,1,4.923-2.246,5.731,5.731,0,0,1,4.211,1.684A7.243,7.243,0,0,1,89.142,14l-2.988.855a3.94,3.94,0,0,0-1.141-2.229A2.9,2.9,0,0,0,83,11.855a3.225,3.225,0,0,0-2.707,1.415,8.024,8.024,0,0,0-1.048,4.676q0,3.381,1.021,4.809a3.122,3.122,0,0,0,2.652,1.428,2.761,2.761,0,0,0,2.067-.909,5.7,5.7,0,0,0,1.258-2.886"
          transform="translate(32.695 3.765)"
        />
        <path
          d="M114.4,26.874h-3.275l-1.312-4.052H103.82l-1.236,4.052H99.37l5.829-17.9h3.2Zm-5.559-7.08-2.067-6.64-2.027,6.64Z"
          transform="translate(42.674 3.856)"
        />
        <path
          d="M141.282,26.874V8.979h4.856a15.181,15.181,0,0,1,3.548.256,4.012,4.012,0,0,1,2.2,1.771,6.393,6.393,0,0,1,.865,3.491A6.486,6.486,0,0,1,152,17.75a4.291,4.291,0,0,1-1.867,1.843,9.87,9.87,0,0,1-3.86.53H144.3v6.751ZM144.3,12.007V17.1h1.672a7.443,7.443,0,0,0,2.29-.233,2.029,2.029,0,0,0,.992-.838,2.71,2.71,0,0,0,.386-1.487,2.7,2.7,0,0,0-.4-1.505,1.969,1.969,0,0,0-.986-.821,9.259,9.259,0,0,0-2.483-.207Z"
          transform="translate(60.673 3.856)"
        />
        <path
          d="M163.885,21.131l2.95-.342q.5,3.431,3.262,3.429a3.116,3.116,0,0,0,2.154-.7,2.242,2.242,0,0,0,.785-1.74,1.877,1.877,0,0,0-.274-1.036,2.009,2.009,0,0,0-.833-.7,23.679,23.679,0,0,0-2.714-.921,9.273,9.273,0,0,1-2.826-1.244,4.741,4.741,0,0,1-1.427-1.761,5.314,5.314,0,0,1-.529-2.349,5.152,5.152,0,0,1,.679-2.634,4.393,4.393,0,0,1,1.874-1.768,6.547,6.547,0,0,1,2.95-.6,5.757,5.757,0,0,1,4.121,1.4,5.534,5.534,0,0,1,1.568,4.015l-3.025.159a3.171,3.171,0,0,0-.859-2.013,2.776,2.776,0,0,0-1.88-.575,3.07,3.07,0,0,0-1.881.5,1.505,1.505,0,0,0-.659,1.241,1.538,1.538,0,0,0,.6,1.229,8.562,8.562,0,0,0,2.752,1.1,11.4,11.4,0,0,1,3.292,1.361,4.651,4.651,0,0,1,1.55,1.843,6.356,6.356,0,0,1,.536,2.74,5.561,5.561,0,0,1-1.464,3.917,5.938,5.938,0,0,1-4.576,1.587q-5.5,0-6.125-6.139"
          transform="translate(70.379 3.764)"
        />
        <path
          d="M201.513,26.874h-3.275l-1.309-4.052h-5.992L189.7,26.874h-3.211l5.826-17.9h3.2Zm-5.558-7.08-2.067-6.64-2.028,6.64Z"
          transform="translate(80.086 3.856)"
        />
        <path
          d="M67.78,57.218h9.064l-.58,1.561H65.4V48.211H67.78ZM57.657,49.765l.577-1.554H46.191V58.78H57.672l.577-1.554H48.572V54.233h6.771l.572-1.542H48.572V49.765Zm-32.608,0h6.777v9.014h2.381V49.765H40.39l.577-1.554H25.626Zm136.383,8.908h2.381V48.211h-2.381ZM16.752,52.634h-7.3A1.326,1.326,0,0,1,8,51.331v-.3a1.309,1.309,0,0,1,1.422-1.272h9.856l.579-1.554H8.734A2.81,2.81,0,0,0,5.682,50.9v.692a2.86,2.86,0,0,0,3.109,2.76h7.3a1.326,1.326,0,0,1,1.449,1.3v.3a1.309,1.309,0,0,1-1.422,1.272H6.261l-.579,1.554H16.809a2.81,2.81,0,0,0,3.052-2.687v-.692a2.859,2.859,0,0,0-3.109-2.759m164.625,0h-7.3a1.326,1.326,0,0,1-1.449-1.3v-.3a1.309,1.309,0,0,1,1.422-1.272h9.856l.579-1.554H173.358a2.81,2.81,0,0,0-3.052,2.687v.692a2.86,2.86,0,0,0,3.109,2.76h7.3a1.326,1.326,0,0,1,1.449,1.3v.3a1.309,1.309,0,0,1-1.424,1.272h-9.855l-.579,1.554h11.127a2.81,2.81,0,0,0,3.052-2.687v-.692a2.859,2.859,0,0,0-3.109-2.759m-48.141,3.4-9.995-7.826h-2.381V58.673h2.381V50.827l9.995,7.846h2.381V48.211h-2.381ZM98.985,58.673h2.552l5.739-10.462h-2.552Zm8.681-10.462L113.4,58.673h2.552l-5.739-10.462Zm-22.148,0H83.136V58.779H94l.58-1.561H85.518Zm54.962,1.554h6.777v9.014h2.381V49.765h6.184l.577-1.554H141.057ZM96.569,59.132a1.095,1.095,0,1,0,1.094,1.095,1.1,1.1,0,0,0-1.094-1.095m2.9,3.242a1.095,1.095,0,1,0,1.095,1.095,1.1,1.1,0,0,0-1.095-1.095M119.5,60.227a1.094,1.094,0,1,0-1.094,1.095,1.094,1.094,0,0,0,1.094-1.095m-3.978,2.239a1.094,1.094,0,1,0,1.095,1.094,1.094,1.094,0,0,0-1.095-1.094m-3.749,2.168a1.095,1.095,0,1,0,1.095,1.095,1.095,1.095,0,0,0-1.095-1.095m-7.549,1.095a1.095,1.095,0,1,0-1.095,1.095,1.1,1.1,0,0,0,1.095-1.095m-15.851-14.7a.557.557,0,1,0,.6.507.557.557,0,0,0-.6-.507m2.42,10.646a.557.557,0,1,0,.6.507.558.558,0,0,0-.6-.507m4.336,4.594a.557.557,0,1,0,.6.506.555.555,0,0,0-.6-.506m5.842,2.946a.557.557,0,1,0,.6.506.556.556,0,0,0-.6-.506m6.475.746a.557.557,0,1,0,.6.506.557.557,0,0,0-.6-.506m6.724-.918a.557.557,0,1,0,.6.507.557.557,0,0,0-.6-.507m5.7-2.776a.557.557,0,1,0,.6.507.557.557,0,0,0-.6-.507m4.33-4.584a.557.557,0,1,0,.6.507.558.558,0,0,0-.6-.507m2.191-5.395a.557.557,0,1,0,.6.506.556.556,0,0,0-.6-.506m-36.1-10.564a.557.557,0,1,0,.506-.6.557.557,0,0,0-.506.6m4.934-4.067a.557.557,0,1,0-.6-.506.556.556,0,0,0,.6.506m5.593-2.789a.557.557,0,1,0-.6-.507.557.557,0,0,0,.6.507M90.574,42.437a.293.293,0,1,0-.317-.267.293.293,0,0,0,.317.267m-3.619,18.8a.293.293,0,1,0-.051-.585.293.293,0,0,0,.051.585m3.619,4.817a.293.293,0,1,0-.317-.267.292.292,0,0,0,.317.267m5.758,4.118a.293.293,0,1,0-.317-.267.293.293,0,0,0,.317.267m7.329,2.656a.293.293,0,1,0-.317-.266.292.292,0,0,0,.317.266m7.719,0a.293.293,0,0,0-.051-.585.293.293,0,1,0,.051.585m7.329-2.644a.293.293,0,0,0-.051-.585.293.293,0,1,0,.051.585m5.861-4.072a.293.293,0,1,0-.317-.267.293.293,0,0,0,.317.267m3.516-4.874a.293.293,0,1,0-.317-.267.295.295,0,0,0,.317.267M96.332,38.319a.293.293,0,1,0-.317-.267.293.293,0,0,0,.317.267m7.329-2.657a.293.293,0,1,0-.317-.266.292.292,0,0,0,.317.266M95.372,52.85a1.094,1.094,0,1,0-1.094-1.095,1.1,1.1,0,0,0,1.094,1.095m1.2-4.075a1.094,1.094,0,1,0-1.095-1.094,1.094,1.094,0,0,0,1.095,1.094m2.9-3.242a1.094,1.094,0,1,0-1.095-1.094,1.094,1.094,0,0,0,1.095,1.094m3.662-2.259a1.095,1.095,0,1,0-1.095-1.095,1.1,1.1,0,0,0,1.095,1.095m4.364-.646a1.095,1.095,0,1,0-1.095-1.095,1.1,1.1,0,0,0,1.095,1.095m0,24.9a1.094,1.094,0,1,0-1.094-1.095,1.1,1.1,0,0,0,1.094,1.095M95.157,43.578a.86.86,0,1,0,.859.859.86.86,0,0,0-.859-.859m-2.739,4.5a.86.86,0,1,0,.859.859.859.859,0,0,0-.859-.859m-1.049,5.047a.859.859,0,1,0,.859.859.859.859,0,0,0-.859-.859M99.336,40.19a.859.859,0,1,0,.859.859.859.859,0,0,0-.859-.859m5.445-1.833a.859.859,0,1,0,.859.859.859.859,0,0,0-.859-.859m2.713-1.524a.557.557,0,1,0,.557.557.557.557,0,0,0-.557-.557m16.7,8.288a.557.557,0,1,0,.507.6.558.558,0,0,0-.507-.6m-3.824-3.97a.557.557,0,1,0-.6.506.558.558,0,0,0,.6-.506m-5.593-2.79a.557.557,0,1,0-.6.507.559.559,0,0,0,.6-.507m9.96,3.808a.293.293,0,1,0-.317.267.293.293,0,0,0,.317-.267m-5.759-4.118a.293.293,0,1,0-.317.267.293.293,0,0,0,.317-.267M111.645,35.4a.293.293,0,1,0-.317.266.291.291,0,0,0,.317-.266m7.869,12.285a1.094,1.094,0,1,0-1.094,1.094,1.094,1.094,0,0,0,1.094-1.094m-2.9-3.242a1.094,1.094,0,1,0-1.094,1.094,1.095,1.095,0,0,0,1.094-1.094m-3.662-2.26a1.094,1.094,0,1,0-1.094,1.095,1.095,1.095,0,0,0,1.094-1.095m6.021,2.259a.859.859,0,1,0,.859-.859.86.86,0,0,0-.859.859m.06,19.032a.86.86,0,1,0,.859-.859.859.859,0,0,0-.859.859m-4.237,3.4a.859.859,0,1,0,.859-.861.859.859,0,0,0-.859.861m-5.328,1.682a.86.86,0,1,0,.861-.861.86.86,0,0,0-.861.861m-5.539.064a.859.859,0,1,0,.859-.859.859.859,0,0,0-.859.859m-5.4-1.631a.859.859,0,1,0,.859-.859.86.86,0,0,0-.859.859M94.3,63.436a.859.859,0,1,0,.859-.859.859.859,0,0,0-.859.859m20.5-22.386a.859.859,0,1,0,.859-.859.859.859,0,0,0-.859.859m-5.445-1.833a.86.86,0,1,0,.861-.859.86.86,0,0,0-.861.859m18.737,9.519a.293.293,0,1,0-.317-.267.293.293,0,0,0,.317.267"
          transform="translate(2.44 15.063)"
        />
      </g>
    </svg>
    <!-- Plus Icon -->
    <svg
      id="plus-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.952 15.952"
      aria-labelledby="titlePlusIcon contentPlusIcon"
      role="img"
    >
      <title v-if="getString('plus-icon', 'title')" id="titlePlusIcon">
        {{ getString('plus-icon', 'title') }}
      </title>
      <desc id="contentPlusIcon">
        {{ getString('plus-icon', 'description') }}
      </desc>
      <g id="Livello_2" data-name="Livello 2">
        <g id="Livello_1-2" data-name="Livello 1">
          <path
            class="cls-1"
            d="M14.38,6.42H9.56V1.57a1.58,1.58,0,0,0-3.15,0V6.42H1.57a1.57,1.57,0,0,0,0,3.14H6.41v4.82a1.58,1.58,0,1,0,3.15,0V9.56h4.82A1.58,1.58,0,0,0,16,8,1.57,1.57,0,0,0,14.38,6.42Z"
          />
        </g>
      </g>
    </svg>
    <!-- Select option list -->
    <svg
      id="icon-select-option-list"
      viewBox="0 0 15.146 8.503"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleSelectOptionList contentSelectOptionList"
      role="img"
    >
      <title
        v-if="getString('icon-select-option-list', 'title')"
        id="titleSelectOptionList"
      >
        {{ getString('icon-select-option-list', 'title') }}
      </title>
      <desc id="contentSelectOptionList">
        {{ getString('icon-select-option-list', 'description') }}
      </desc>
      <g transform="translate(15.146) rotate(90)">
        <path
          d="M8.231,6.893,1.61.272a.958.958,0,0,0-1.338,0,.958.958,0,0,0,0,1.338L6.235,7.573.272,13.536a.958.958,0,0,0,0,1.338.958.958,0,0,0,1.338,0L8.231,8.231a.958.958,0,0,0,0-1.338"
        />
      </g>
    </svg>
    <!-- Minus Icon -->
    <svg
      id="minus-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.96 3.15"
      aria-labelledby="titleMinusIcon contentMinusIcon"
      role="img"
    >
      <title v-if="getString('minus-icon', 'title')" id="titleMinusIcon">
        {{ getString('minus-icon', 'title') }}
      </title>
      <desc id="contentMinusIcon">
        {{ getString('minus-icon', 'description') }}
      </desc>
      <g id="Livello_2" data-name="Livello 2">
        <g id="Livello_1-2" data-name="Livello 1">
          <g id="Raggruppa_328" data-name="Raggruppa 328">
            <path
              id="Tracciato_79"
              data-name="Tracciato 79"
              class="cls-1"
              d="M1.57,0H14.38A1.57,1.57,0,0,1,16,1.56a1.59,1.59,0,0,1-1.58,1.59H1.57A1.58,1.58,0,0,1,1.57,0Z"
            />
          </g>
        </g>
      </g>
    </svg>
    <!-- GeoLocate Icon -->
    <svg
      id="geolocate-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.76 27.76"
      aria-labelledby="titleGeolocateIcon contentGeolocateIcon"
      role="img"
    >
      <title
        v-if="getString('geolocate-icon', 'title')"
        id="titleGeolocateIcon"
      >
        {{ getString('geolocate-icon', 'title') }}
      </title>
      <desc id="contentGeolocateIcon">
        {{ getString('geolocate-icon', 'description') }}
      </desc>
      <g id="Livello_2" data-name="Livello 2">
        <g id="Livello_1-2" data-name="Livello 1">
          <g id="_265_Location" data-name=" 265 Location">
            <g id="Group-8">
              <path
                id="Fill-1"
                class="cls-1"
                d="M13.84,17a3.09,3.09,0,1,1,3.08-3.08h0A3.08,3.08,0,0,1,13.84,17m0-7.93a4.85,4.85,0,1,0,4.84,4.85A4.85,4.85,0,0,0,13.84,9"
              />
              <path
                id="Fill-3"
                class="cls-1"
                d="M13.84,12.47a1.42,1.42,0,1,0,1.41,1.42,1.42,1.42,0,0,0-1.41-1.42"
              />
              <g id="Group-7">
                <path
                  id="Fill-5"
                  class="cls-1"
                  d="M14.76,23.84V21.46H13v2.39a10,10,0,0,1-9.12-9.09H6.3V13H3.88A10,10,0,0,1,13,3.93V6.3h1.76V3.93a10,10,0,0,1,9,9.07H21.46v1.76H23.8a10,10,0,0,1-9,9.08ZM27.76,13h-2.2A11.77,11.77,0,0,0,14.76,2.17V0H13V2.17A11.77,11.77,0,0,0,2.12,13H0v1.76H2.12A11.78,11.78,0,0,0,13,25.61v2.15h1.76V25.6a11.77,11.77,0,0,0,10.8-10.84h2.2Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <!--Location icon-->
    <svg
      id="icon-location"
      viewBox="0 0 10.64 14.78"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleLocation contentLocation"
      role="img"
    >
      <title v-if="getString('icon-location', 'title')" id="titleLocation">
        {{ getString('icon-location', 'title') }}
      </title>
      <desc id="contentLocation">
        {{ getString('icon-location', 'description') }}
      </desc>
      <g id="Livello_2" data-name="Livello 2">
        <g id="Livello_1-2" data-name="Livello 1">
          <g id="_069_Place_On_Map" data-name=" 069 Place On Map">
            <g
              id="_0865_OnMap_Med_IVI_Solid"
              data-name=" 0865 OnMap Med IVI Solid"
            >
              <path
                id="_0865_OnMap"
                data-name=" 0865 OnMap"
                d="M5.32,0a5.31,5.31,0,0,1,5.32,5.27c0,3.68-4.65,8.79-4.85,9h0l-.47.51-.46-.51C4.66,14.06,0,9,0,5.27A5.3,5.3,0,0,1,5.32,0Zm0,.64A4.65,4.65,0,0,0,.64,5.26h0c0,3.48,4.68,8.57,4.68,8.57S10,8.75,10,5.27A4.66,4.66,0,0,0,5.33.64Zm0,2.82A1.81,1.81,0,1,1,3.51,5.27,1.81,1.81,0,0,1,5.32,3.46Zm0,.64A1.17,1.17,0,1,0,6.49,5.27h0A1.17,1.17,0,0,0,5.32,4.1Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
    <!-- Lock Icon -->
    <svg
      id="icon-lock"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleLock contentLock"
      role="img"
    >
      <title v-if="getString('icon-lock', 'title')" id="titleLock">
        {{ getString('icon-lock', 'title') }}
      </title>
      <desc id="contentLock">
        {{ getString('icon-lock', 'description') }}
      </desc>
      <path
        fill-rule="evenodd"
        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
        clip-rule="evenodd"
      />
    </svg>
    <!-- Unlock Icon -->
    <svg
      id="icon-unlock"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleUnlock contentUnlock"
      role="img"
    >
      <title v-if="getString('icon-unlock', 'title')" id="titleUnlock">
        {{ getString('icon-unlock', 'title') }}
      </title>
      <desc id="contentUnlock">
        {{ getString('icon-unlock', 'description') }}
      </desc>
      <path
        d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z"
      />
    </svg>
    <!-- Close Icon -->
    <svg
      id="icon-close"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleClose contentClose"
      role="img"
    >
      <title v-if="getString('icon-close', 'title')" id="titleClose">
        {{ getString('icon-close', 'title') }}
      </title>
      <desc id="contentClose">
        {{ getString('icon-close', 'description') }}
      </desc>
      <path
        d="M18.71,17.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.41l-5.29,5.3a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.59,12,5.29,6.71A1,1,0,0,1,6.71,5.29L12,10.59l5.29-5.3a1,1,0,1,1,1.42,1.42L13.41,12Z"
      />
    </svg>
    <!-- Icon Eye -->
    <svg
      id="icon-eye"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleEye contentEye"
      role="img"
    >
      <title v-if="getString('icon-eye', 'title')" id="titleEye">
        {{ getString('icon-eye', 'title') }}
      </title>
      <desc id="contentEye">
        {{ getString('icon-eye', 'description') }}
      </desc>
      <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
      <path
        fill-rule="evenodd"
        d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
        clip-rule="evenodd"
      />
    </svg>
    <!-- Icon Closed Eye -->
    <svg
      id="icon-closed-eye"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleClosedEye contentClosedEye"
      role="img"
    >
      <title v-if="getString('icon-closed-eye', 'title')" id="titleClosedEye">
        {{ getString('icon-closed-eye', 'title') }}
      </title>
      <desc id="contentClosedEye">
        {{ getString('icon-closed-eye', 'description') }}
      </desc>
      <path
        fill-rule="evenodd"
        d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
        clip-rule="evenodd"
      />
      <path
        d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
      />
    </svg>
    <!-- Icon search -->
    <svg
      id="icon-search"
      viewBox="0 0 28.78 26.6"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleSearch contentSearch"
      role="img"
    >
      <title v-if="getString('icon-search', 'title')" id="titleClose">
        {{ getString('icon-search', 'title') }}
      </title>
      <desc id="contentClose">
        {{ getString('icon-search', 'description') }}
      </desc>
      <g>
        <g>
          <g>
            <path
              d="M28.78,23.85l-7.63-6.49a11.41,11.41,0,1,0-2.34,2.74l7.64,6.5ZM4.9,19.27a10.2,10.2,0,1,1,6.52,2.36A10.2,10.2,0,0,1,4.9,19.27"
            />
          </g>
        </g>
      </g>
    </svg>
    <!-- Angle left -->
    <svg
      id="icon-angle-left"
      viewBox="0 0 8.684 16.025"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleAngleLeft contentAngleLeft"
      role="img"
    >
      <title v-if="getString('icon-angle-left', 'title')" id="titleAngleLeft">
        {{ getString('icon-angle-left', 'title') }}
      </title>
      <desc id="contentAngleLeft">
        {{ getString('icon-angle-left', 'description') }}
      </desc>
      <path
        d="M.2,15.827a.667.667,0,0,1,0-.948L7.072,8.012.2,1.144A.67.67,0,1,1,1.145.2L8.487,7.538a.667.667,0,0,1,0,.948L1.145,15.827a.667.667,0,0,1-.948,0Z"
        transform="translate(8.684 16.025) rotate(180)"
      />
    </svg>
    <!-- Angle right -->
    <svg
      id="icon-angle-right"
      viewBox="0 0 8.684 16.025"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleAngleRight contentAngleRight"
      role="img"
    >
      <title v-if="getString('icon-angle-right', 'title')" id="titleAngleRight">
        {{ getString('icon-angle-right', 'title') }}
      </title>
      <desc id="contentAngleRight">
        {{ getString('icon-angle-right', 'description') }}
      </desc>
      <path
        d="M17.692,27.823a.667.667,0,0,1,0-.948l6.875-6.868L17.692,13.14a.67.67,0,1,1,.948-.948l7.342,7.342a.667.667,0,0,1,0,.948l-7.342,7.342a.667.667,0,0,1-.948,0Z"
        transform="translate(-17.494 -11.996)"
      />
    </svg>
    <!-- Download -->
    <svg
      id="icon-download"
      viewBox="0 0 28.76 44.653"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleDownload contentDownload"
      role="img"
    >
      <title v-if="getString('icon-download', 'title')" id="titleDownload">
        {{ getString('icon-download', 'title') }}
      </title>
      <desc id="contentDownload">
        {{ getString('icon-download', 'description') }}
      </desc>
      <path
        d="M45.38,19a1.514,1.514,0,0,0-1.514,1.514V50.637L33.608,39.9a1.514,1.514,0,0,0-2.189,2.092L45.38,56.6,59.341,41.994A1.514,1.514,0,0,0,57.152,39.9L46.894,50.637V20.514A1.514,1.514,0,0,0,45.38,19Z"
        transform="translate(-31 -19)"
      />
      <path
        d="M57.732,74H33.514a1.514,1.514,0,0,0,0,3.027H57.732a1.514,1.514,0,0,0,0-3.027Z"
        transform="translate(-31.243 -32.374)"
      />
    </svg>
    <!-- Danger -->
    <svg
      id="icon-danger"
      viewBox="0 0 67 67"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleDanger contentDanger"
      role="img"
    >
      <title v-if="getString('icon-danger', 'title')" id="titleDanger">
        {{ getString('icon-danger', 'title') }}
      </title>
      <desc id="contentDanger">
        {{ getString('icon-danger', 'description') }}
      </desc>
      <path
        d="M60.785,67.8H27.406a8.221,8.221,0,0,1-7.126-12.311L36.977,26.6a8.19,8.19,0,0,1,7.111-4.106,8.316,8.316,0,0,1,4.107,1.09,8,8,0,0,1,3.026,3.028L67.9,55.472a8.254,8.254,0,0,1,.817,6.246A8.084,8.084,0,0,1,64.885,66.7,8.351,8.351,0,0,1,60.785,67.8Zm-16.7-42.259a5.145,5.145,0,0,0-4.471,2.577L22.922,56.995a5.178,5.178,0,0,0,4.484,7.757h33.38a5.3,5.3,0,0,0,2.6-.7,5.06,5.06,0,0,0,2.4-3.122,5.222,5.222,0,0,0-.516-3.949L48.579,28.122a4.977,4.977,0,0,0-1.886-1.891A5.272,5.272,0,0,0,44.088,25.537Z"
        transform="translate(-10.626 -12.456)"
      />
      <path
        d="M-2.14,14.891a1.725,1.725,0,0,1-1.725-1.725V-2.14A1.725,1.725,0,0,1-2.14-3.865,1.725,1.725,0,0,1-.415-2.14V13.166A1.725,1.725,0,0,1-2.14,14.891Z"
        transform="translate(35.609 25.435)"
      />
      <circle
        cx="2.454"
        cy="2.454"
        r="2.454"
        transform="translate(31.015 43.331)"
      />
    </svg>
    <!-- Attachment -->
    <svg
      id="icon-attachment"
      viewBox="0 0 10.79 19.093"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleAttachment contentAttachment"
      role="img"
    >
      <title v-if="getString('icon-attachment', 'title')" id="titleAttachment">
        {{ getString('icon-attachment', 'title') }}
      </title>
      <desc id="contentAttachment">
        {{ getString('icon-attachment', 'description') }}
      </desc>
      <path
        d="M379.9,236.871l.056,8.348a.895.895,0,1,1-1.789.013l-.056-8.349a3.578,3.578,0,1,0-7.156.048l.066,9.839a2.087,2.087,0,1,0,4.175-.028l-.062-9.243a.6.6,0,1,0-1.193.008l.052,7.753a.895.895,0,0,1-1.789.012l-.052-7.753a2.385,2.385,0,0,1,4.771-.032l.062,9.243a3.876,3.876,0,1,1-7.752.052l-.066-9.84a5.367,5.367,0,0,1,10.734-.072"
        transform="translate(-369.165 -231.54)"
      />
    </svg>
    <!-- Uploaded -->
    <svg
      id="icon-uploaded"
      viewBox="0 0 39.037 42.38"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleUploaded contentUploaded"
      role="img"
    >
      <title v-if="getString('icon-uploaded', 'title')" id="titleUploaded">
        {{ getString('icon-uploaded', 'title') }}
      </title>
      <desc id="contentUploaded">
        {{ getString('icon-uploaded', 'description') }}
      </desc>
      <g
        transform="translate(1 1)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="2"
      >
        <path
          d="M22.3,37.938H4V2H19.973L30.621,12.648v7.986"
          transform="translate(-4 -2)"
        />
        <path d="M28,2V12.648H38.648" transform="translate(-12.027 -2)" />
        <circle
          cx="10.5"
          cy="10.5"
          r="10.5"
          transform="translate(16.037 19.38)"
        />
        <path
          d="M46.652,42l-5.324,5.99L38,44.662"
          transform="translate(-15.372 -15.379)"
        />
      </g>
    </svg>
    <!-- Ellipsis loader -->
    <svg
      id="icon-ellipsis-loader"
      viewBox="-2 22 56 56"
      enable-background="new 0 0 0 0"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      aria-labelledby="titleEllipsisLoader contentEllipsisLoader"
      role="img"
    >
      <title
        v-if="getString('icon-ellipsis-loader', 'title')"
        id="titleEllipsisLoader"
      >
        {{ getString('icon-ellipsis-loader', 'title') }}
      </title>
      <desc id="contentEllipsisLoader">
        {{ getString('icon-ellipsis-loader', 'description') }}
      </desc>
      <circle stroke="none" cx="6" cy="50" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle stroke="none" cx="26" cy="50" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle stroke="none" cx="46" cy="50" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
    <!-- Peugeot Logo -->
    <svg
      id="logo-peugeot"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 328.34 361.59"
      aria-labelledby="titleLogoPeugeot contentLogoPeugeot"
      role="img"
    >
      <title
        v-if="getString('icon-logo-peugeot', 'title')"
        id="titleLogoPeugeot"
      >
        {{ getString('icon-logo-peugeot', 'title') }}
      </title>
      <desc id="contentLogoPeugeot">
        {{ getString('icon-logo-peugeot', 'description') }}
      </desc>
      <g>
        <path
          d="M88.27,220.49a1.33,1.33,0,0,1-1.68-.83,1.55,1.55,0,0,1-.06-.23C86.08,217.54,85,211,84.72,209c-.14-1.06.15-1.66,1.14-2,4.68-1.5,12.54-4.15,18.87-6.41a4.89,4.89,0,0,0,3-2.72c2.65-4.23,9.14-15.7,12.24-21.66a2.74,2.74,0,0,0-.08-2.65l-1.43-2.34a4.45,4.45,0,0,0-2.49-1.89c-6.41-1.66-14.94-3.77-19-4.68a5.52,5.52,0,0,0-2.71.08l-.76.22c6.19,2.12,11.4,4,18.12,6.5a2.51,2.51,0,0,1,1.32,1.43l.61,2a3.52,3.52,0,0,1-.23,2.49A106,106,0,0,1,101.7,195a5.58,5.58,0,0,1-2.19,1.59c-3.77,1.43-10.58,3.7-13.66,4.46a1.45,1.45,0,0,1-1.33-.23,87.05,87.05,0,0,1-6.71-5.74s-.39,4.61-.39,6.62a2.6,2.6,0,0,0,.15.67c.75,1.81,2.11,5.21,2.71,7a8.65,8.65,0,0,1,.38,1.32c.76,3,2.87,11.91,2.87,11.91.31,1.32,1.06,1.81,2.26,1.58,1.51-.3,6.42-1.73,8.45-2.34a2.73,2.73,0,0,0,.84-.45l3.47-3.17s-7.47,1.66-10.26,2.19"
        />
        <path
          d="M99.41,193.24A115.48,115.48,0,0,0,108,180.78L87.57,197.69c3.31-1.06,7.93-2.56,10.57-3.62a2.69,2.69,0,0,0,1.21-.83"
        />
        <path
          d="M99.81,125.15l-3.7.3a.52.52,0,0,0-.53.51v0l-.3,4.38a.34.34,0,0,0,.32.38h.06l3.7-.83a1.75,1.75,0,0,0,1.14-.9,4,4,0,0,0,.08-3.32.68.68,0,0,0-.76-.53"
        />
        <path
          d="M64.12,179.58l5.58,6.49,1.67-11.25a10.08,10.08,0,0,0-7.25,4.76"
        />
        <path
          d="M245.49,178.37a245.23,245.23,0,0,0-27.7-34A6.23,6.23,0,0,0,216,143l-2.34-1s4.07,18,6,27.76a6.22,6.22,0,0,0,1.73,3.32,102,102,0,0,1,14,16.31,15.12,15.12,0,0,1,2.56,7.55,252.53,252.53,0,0,1-1.06,44.84,5.08,5.08,0,0,1-2.34,4.15c-13.66,11-36.31,30.49-46,40.16a9.65,9.65,0,0,0-2,2.42,53.83,53.83,0,0,0-2.64,4.76A76.74,76.74,0,0,1,181,282.36a12.57,12.57,0,0,1,0-4.15,297.39,297.39,0,0,1,7.85-30.12,2.5,2.5,0,0,0,.15-.76v-1.81a389,389,0,0,0-15.1,36.84,5.27,5.27,0,0,0,.08,3.77c1.32,4,5.43,13.88,7.32,18,0,0,4.38-8.22,6.94-12.46a17.4,17.4,0,0,1,2.57-3.17c7.63-7.1,35.09-30,47.93-39.67a6,6,0,0,0,2.73-4,176.1,176.1,0,0,0,4.82-64.08,6,6,0,0,0-.83-2.42"
        />
        <path
          d="M189.27,120.43a4.25,4.25,0,0,0,.52-3c-.44-2.48-1-5.43-1.58-7.63a1.41,1.41,0,0,0-.76-1l-3.84-1.9a3.18,3.18,0,0,0-1.67-.22c-9.36,1.67-19.17,3.62-26.57,5.29A2.24,2.24,0,0,0,154,113l-2.34,4a.51.51,0,0,0,.21.7.49.49,0,0,0,.17.06c2,.38,5.88,1.06,7.25,1.32a2.82,2.82,0,0,0,1.81-.15c4.68-2,12.37-4.9,18.11-7a2.33,2.33,0,0,1,1.43,0l2.65.84a1.78,1.78,0,0,1,.9.75c.75,1.32,1.42,2.64,1.89,3.54a2.49,2.49,0,0,1-.39,2.34c-1.95,2.79-5.29,7.25-7.55,10a2.32,2.32,0,0,0-.45,2.2c1.32,4.6,4.23,14.11,5.82,18.72a3.27,3.27,0,0,0,.91,1.32l2.2,2s-3.48-16.08-4.3-20.68a2.65,2.65,0,0,1,.3-2c1.82-2.72,5.14-7.69,6.72-10.48"
        />
        <path
          d="M272.67,133.68a3.86,3.86,0,0,0-1.67-2.49,239.55,239.55,0,0,0-40.38-23.47,6.27,6.27,0,0,0-4.53-.08c-5.35,2-13.82,5.52-22.71,9.67,0,0,4,.3,5.73.53a5.79,5.79,0,0,0,2.27-.15c2.72-.75,7.55-2,11.31-2.79A6.27,6.27,0,0,1,228,116c5.21,3.85,13.58,10.58,19,15.1A11.72,11.72,0,0,0,250,133c8.14,3.24,11.77,4.91,13.58,5.82a5.06,5.06,0,0,1,2.56,3.24,205.41,205.41,0,0,1,4.3,29.82,11.41,11.41,0,0,1-.67,5,147.09,147.09,0,0,1-11.18,22.48,5.53,5.53,0,0,1-1.14,1.32c-1.13,1-3.09,2.57-4.6,3.71a1.06,1.06,0,0,0-.45.9c0,3.54-.67,10.26-.67,10.26a201.29,201.29,0,0,0,21.88-36.08,6.85,6.85,0,0,0,.84-2.79,148.89,148.89,0,0,0-1.81-42.87"
        />
        <path
          d="M168.66,309.39c-1.81-4.15-11.39-26.87-14-35.56a14.2,14.2,0,0,1-.67-7.39,574.55,574.55,0,0,1,11-59.93,4.55,4.55,0,0,0,.08-2.26l-1.32-7.85a504.81,504.81,0,0,0-20.38,60.82,9.16,9.16,0,0,0,.08,6.62,453,453,0,0,0,26.34,52.31l-.67-5.36a10,10,0,0,0-.39-1.32"
        />
        <path
          d="M153.71,310.63,149,307.54a19.21,19.21,0,0,1-2.12-1.59,365.21,365.21,0,0,1-42.31-53.9,8.85,8.85,0,0,1-1.59-5.88c.15-2.71.68-8.08,1.2-11.17a6.66,6.66,0,0,1,2.42-4.69c4.53-4.07,11.91-11.47,15.7-15.32a19,19,0,0,0,3.4-4.46c3.48-6.61,14.19-29.82,17.81-39.4a6.38,6.38,0,0,0,.45-4q-1.89-9.09-4.68-18l-.38,4.3a3.42,3.42,0,0,0,.07.9,109,109,0,0,1,1.51,13.13,5.58,5.58,0,0,1-.75,3.17A415.27,415.27,0,0,1,100,224.81a9.33,9.33,0,0,0-2.34,4.83c-.68,3.24-1.43,10.58-2,16.45a9.47,9.47,0,0,0,2,7.55,346.43,346.43,0,0,0,44.15,52.54,17.74,17.74,0,0,0,1.89,1.32c3.1,1.66,11.7,5.88,11.7,5.88L154.09,311a2.4,2.4,0,0,0-.45-.45"
        />
        <path
          d="M114.16,120.77l16.91-5.29a4.11,4.11,0,0,0,2.34-1.89L142.47,98a.57.57,0,0,0-.2-.76.55.55,0,0,0-.25-.07l-7.7.08a7.15,7.15,0,0,0-2.19.38A170.08,170.08,0,0,0,110.47,107a4.64,4.64,0,0,0-1.59,1.33l-8.14,10a3.28,3.28,0,0,1-1,.76l-5.29,2.26a1.31,1.31,0,0,0-.61.53l-.22.53s11.17-.39,14.94-.61a24.69,24.69,0,0,0,5.58-1.14"
        />
        <path
          d="M145.18,84.16C166.47,82.57,191,83,197,83.18a8,8,0,0,1,2.65.45L204,85.06c-10.72.53-36.53,2.87-47,4.68l3.7.61a1.4,1.4,0,0,0,.76,0c7.77-.45,22.87-1,29.51-1.06a10.32,10.32,0,0,1,4.15.75c3.85,1.51,11.63,5,14.87,6.61a10.23,10.23,0,0,0,4.6,1.21c3.48.14,8.83.53,12.76.9a11.1,11.1,0,0,1,3.09.91,271.48,271.48,0,0,1,24.39,14.27,4.11,4.11,0,0,0,1.32.53l3.24.67s-10.49-10.72-14.64-14.35a9,9,0,0,0-2-1.32,414.37,414.37,0,0,0-37.59-19.54,14.71,14.71,0,0,0-4-1,451.07,451.07,0,0,0-68.08.22,4,4,0,0,0-3,1.67c-.75,1.06-1.89,3-3,4.76a11.88,11.88,0,0,1-2,2.34c-3.4,3-9.06,7.7-12.6,10.42-.31.22-.45.38-.68.53-1.5,1.06-6.41,4.3-7.32,4.9a1.91,1.91,0,0,0-.68.61L102,106.66c14.86-8.38,33.81-18.87,40.31-21.74a7.36,7.36,0,0,1,2.95-.75"
        />
        <path
          d="M75.74,131.34a1.71,1.71,0,0,1-.67.61c-13.22,9.42-20.68,15.47-23.63,18l-3.4,3.4c-.9,1-1.14,1.32-1.2,2.11a19.88,19.88,0,0,0-.08,2,1.32,1.32,0,0,0,.22.75A15.59,15.59,0,0,0,48.49,160a.35.35,0,0,0,.45.08c2-1.32,4.68-3.4,7.17-5.29a3.19,3.19,0,0,0,.67-.75,22.69,22.69,0,0,0,1.32-2.42,2,2,0,0,1,.84-.9c.53-.3,2-1.32,2-1.32A46,46,0,0,1,59,155.62a5.74,5.74,0,0,1-.76,1.13c-1.95,2-5.51,6-7.24,8.15a1.92,1.92,0,0,0,.08,2.34,95,95,0,0,0,7,8.75,4.66,4.66,0,0,0,1.5,1.33,13.24,13.24,0,0,0,1.43.67s1.67-8.15,2.42-10.58a2.43,2.43,0,0,1,1.89-1.81c8.68-2.2,27.4-5.29,27.4-5.29-2-2.34-8.53-9.14-10.58-10.87a3.08,3.08,0,0,0-2-.83c-2.42-.31-10.34-.84-10.34-.84s.67-.75,1.2-1.32a3.27,3.27,0,0,1,1.32-.91c9.73-3.4,22.72-8.3,30.27-11.48a9.66,9.66,0,0,0,3.77-2.56c.61-.61,1.73-1.89,2.42-2.65a.63.63,0,0,0,.22-.45,2.51,2.51,0,0,0,.08-.67s-3.24,2.42-4.52,3.32a9.51,9.51,0,0,1-3.32,1.58c-2.64.68-7.7,1.9-10.58,2.57a2.9,2.9,0,0,1-2-.08c-.45-.15-1.33-.53-2-.75a1.75,1.75,0,0,0-1.51-.15c-2.64.61-9.89,2.34-9.89,2.34s3.32-2.95,3.54-3.17a3.72,3.72,0,0,1,1-.53c2.49-1,5.58-2.12,8.23-3.17a1.22,1.22,0,0,0,.9-1.14c.14-2,.75-5.66,1-7.55a2,2,0,0,1,.68-1.21c1.51-1.2,7.17-5.51,8.45-6.49l.22-.22,1.51-1.89c-4,2.34-11.17,6.61-14.8,8.91a30.36,30.36,0,0,0-4,2.79l-.45.45c-.68,1-4.6,6.11-6.05,8"
        />
        <path
          d="M69.78,57.51V34.73c9.67-.83,19.4-1.59,29.09-2.2v3.71c-8.45.53-16.91,1.13-25.36,1.89v5.66C81,43.18,88.45,42.58,96,42.12v3.7c-7.47.45-14.94,1.06-22.48,1.67v6c8.45-.75,16.91-1.32,25.36-1.89v3.7c-9.73.68-19.4,1.33-29.09,2.27"
        />
        <path
          d="M30.15,61.76V38.93c7.7-1,15.33-1.89,23-2.64a9.5,9.5,0,0,1,3.32.14,4.74,4.74,0,0,1,2.34,1.33A4.53,4.53,0,0,1,60,40a11.52,11.52,0,0,1,.22,2.34v2.65A12.28,12.28,0,0,1,60,47.28a5.36,5.36,0,0,1-1.21,2.34,5.8,5.8,0,0,1-2.34,1.66,9.74,9.74,0,0,1-3.32.76c-6.41.67-12.9,1.43-19.32,2.19v7.1l-3.7.45m3.77-11.32c6.8-.83,13.66-1.58,20.53-2.34a2.42,2.42,0,0,0,2.12-2.34v-4a1.85,1.85,0,0,0-1.79-1.91,1.22,1.22,0,0,0-.33,0c-6.86.67-13.65,1.5-20.53,2.34Z"
        />
        <path
          d="M236.74,55.79a18.56,18.56,0,0,1-3.55-.53,7.52,7.52,0,0,1-2.71-1.32,5,5,0,0,1-1.58-2.34,9.12,9.12,0,0,1-.39-2.64V38.76a7.39,7.39,0,0,1,.39-2.64,4.23,4.23,0,0,1,1.58-2.2,6.47,6.47,0,0,1,2.71-1,18.32,18.32,0,0,1,3.55-.08L251.9,34a18.57,18.57,0,0,1,3.55.61,7.06,7.06,0,0,1,2.71,1.32,5.19,5.19,0,0,1,1.59,2.42,9.48,9.48,0,0,1,.38,2.65V51.19a7.22,7.22,0,0,1-.38,2.65A4.08,4.08,0,0,1,258.16,56a6.4,6.4,0,0,1-2.71.9,26.29,26.29,0,0,1-3.55,0l-15.16-1.14m-2.26-19.25a2,2,0,0,0-2.11,1.77,1.15,1.15,0,0,0,0,.19V49.61a2.31,2.31,0,0,0,2.12,2.26c.6.08,1.32.08,1.89.14h.45l15.1,1.14h.3c.68.08,1.32.08,2,.14a1.89,1.89,0,0,0,2.1-1.67,1.34,1.34,0,0,0,0-.28V40.24a2.43,2.43,0,0,0-2.11-2.34c-6.61-.38-13.22-.9-19.84-1.32"
        />
        <path
          d="M281,59.71V40.6c-4.46-.45-8.91-1-13.36-1.32V35.55c10.12,1,20.3,2.11,30.42,3.4v3.7c-4.46-.53-8.92-1.14-13.36-1.59v19.1l-3.7-.45"
        />
        <path
          d="M189.72,53.6V30.8c9.73.23,19.47.61,29.09,1.14v3.7c-8.45-.45-16.92-.75-25.44-1v5.66c7.47.23,15,.45,22.47.84v3.7c-7.47-.39-15-.68-22.47-.83v6c8.44.22,17,.53,25.44,1v3.7c-9.74-.45-19.4-.75-29.09-1.06"
        />
        <path
          d="M157.41,53.36a23.29,23.29,0,0,1-3.54-.22A6.52,6.52,0,0,1,151.16,52a4.76,4.76,0,0,1-1.59-2.26,8.8,8.8,0,0,1-.38-2.65V37a6.78,6.78,0,0,1,1.66-4.91,8.21,8.21,0,0,1,5.74-1.59c7.17-.07,14.41,0,21.59.08v3.71c-7.69-.08-15.39-.15-23.16-.08a2.12,2.12,0,0,0-2.12,2.14V47.48A2.12,2.12,0,0,0,155,49.59h2.34c6.27-.08,12.53,0,18.79.08v-6c-4.07-.08-8.08-.08-12.15-.08v-3.7c5.29,0,10.57.08,15.86.14V53.49c-7.39-.22-14.94-.22-22.48-.14"
        />
        <path
          d="M116.87,54.35a16.89,16.89,0,0,1-3.55-.14,6.47,6.47,0,0,1-2.71-1A4.23,4.23,0,0,1,109,51a9.07,9.07,0,0,1-.39-2.64V31.94c1.33-.08,2.49-.15,3.77-.15V48.71a2,2,0,0,0,2,2h.16q9.51-.45,19-.67a2.13,2.13,0,0,0,2.12-2.14V31c1.32,0,2.48-.08,3.77-.08V47.33A7,7,0,0,1,139,50a5.07,5.07,0,0,1-1.58,2.34,6.52,6.52,0,0,1-2.73,1.2,15.6,15.6,0,0,1-3.54.38c-4.76.08-9.59.23-14.35.45"
        />
        <path
          d="M327.24,14.11A950,950,0,0,0,1,14.11C.19,36.38-.71,70.8.87,100.07A319.24,319.24,0,0,0,46,259a275.76,275.76,0,0,0,118.2,102.57A276,276,0,0,0,282.36,259a321.18,321.18,0,0,0,45.13-159c1.59-29.09.61-63.55-.23-85.82m-6,85.51a314.22,314.22,0,0,1-44.23,156,267.27,267.27,0,0,1-112.85,98.95A266.89,266.89,0,0,1,51.29,255.68a315,315,0,0,1-44.23-156c-1.13-20.9-1.13-47.18,0-80.24a945.94,945.94,0,0,1,314.15,0c1.13,33.06,1.13,59.34,0,80.24"
        />
      </g>
    </svg>
    <!-- DS Logo -->
    <svg
      id="logo-ds"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 657.3 500"
      aria-labelledby="titleLogoDs contentLogoDs"
      role="img"
    >
      <title v-if="getString('icon-logo-ds', 'title')" id="titleLogoDs">
        {{ getString('icon-logo-ds', 'title') }}
      </title>
      <desc id="contentLogoDs">
        {{ getString('icon-logo-ds', 'description') }}
      </desc>
      <defs>
        <linearGradient
          id="Sfumatura_senza_nome"
          x1="-1304.3"
          y1="1031.06"
          x2="-1298.67"
          y2="1031.06"
          gradientTransform="translate(46229.75 58107.77) rotate(90) scale(44.44)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#a8a8a7" />
          <stop offset="0.04" stop-color="#a8a8a7" />
          <stop offset="0.2" stop-color="#cbcbca" />
          <stop offset="0.4" stop-color="#f1f1f0" />
          <stop offset="0.51" stop-color="#fff" />
          <stop offset="0.58" stop-color="#fbfbfb" />
          <stop offset="0.65" stop-color="#eee" />
          <stop offset="0.73" stop-color="#d9d8d8" />
          <stop offset="0.81" stop-color="#bbbaba" />
          <stop offset="0.89" stop-color="#959494" />
          <stop offset="0.96" stop-color="#706f6f" />
          <stop offset="1" stop-color="#706f6f" />
        </linearGradient>
        <linearGradient
          id="Sfumatura_senza_nome_10"
          x1="-1229.32"
          y1="954.13"
          x2="-1223.69"
          y2="954.13"
          gradientTransform="translate(13472.7 14346.24) rotate(85) scale(12.33)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#d0d0d0" />
          <stop offset="0.15" stop-color="#9e9e9e" />
          <stop offset="0.21" stop-color="#878787" />
          <stop offset="0.3" stop-color="#7b7b7b" />
          <stop offset="0.46" stop-color="#5a5a5a" />
          <stop offset="0.67" stop-color="#242424" />
          <stop offset="0.81" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="Sfumatura_senza_nome-2"
          x1="-1306.88"
          y1="1030.97"
          x2="-1301.25"
          y2="1030.97"
          gradientTransform="matrix(0, 44.3, -44.3, 0, 46080.51, 57896.4)"
          xlink:href="#Sfumatura_senza_nome"
        />
        <linearGradient
          id="Sfumatura_senza_nome_7"
          x1="-1351.27"
          y1="1097.79"
          x2="-1345.64"
          y2="1097.79"
          gradientTransform="matrix(0, -41.83, 41.83, 0, -45478.52, -56271.87)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#706f6f" />
          <stop offset="0.04" stop-color="#706f6f" />
          <stop offset="0.06" stop-color="#858484" />
          <stop offset="0.09" stop-color="#a6a5a5" />
          <stop offset="0.12" stop-color="#c2c1c1" />
          <stop offset="0.16" stop-color="#d8d8d8" />
          <stop offset="0.2" stop-color="#eaeaea" />
          <stop offset="0.26" stop-color="#f6f6f6" />
          <stop offset="0.33" stop-color="#fdfdfd" />
          <stop offset="0.51" stop-color="#fff" />
          <stop offset="0.65" stop-color="#fdfdfd" />
          <stop offset="0.72" stop-color="#f5f5f5" />
          <stop offset="0.78" stop-color="#e8e8e8" />
          <stop offset="0.83" stop-color="#d5d5d5" />
          <stop offset="0.87" stop-color="#bdbcbc" />
          <stop offset="0.91" stop-color="#9f9e9e" />
          <stop offset="0.95" stop-color="#7c7b7b" />
          <stop offset="0.96" stop-color="#706f6f" />
          <stop offset="1" stop-color="#706f6f" />
        </linearGradient>
        <linearGradient
          id="Sfumatura_senza_nome_7-2"
          x1="-1353.72"
          y1="1096.4"
          x2="-1348.09"
          y2="1096.4"
          gradientTransform="matrix(0, -41.99, 41.99, 0, -45656.06, -56455.96)"
          xlink:href="#Sfumatura_senza_nome_7"
        />
        <linearGradient
          id="Sfumatura_senza_nome_6"
          x1="-1289.67"
          y1="1047.17"
          x2="-1284.03"
          y2="1047.17"
          gradientTransform="translate(57841.81 22102.66) rotate(60) scale(37.2)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#f8f8f8" />
          <stop offset="0.02" stop-color="#f8f8f8" />
          <stop offset="0.4" stop-color="#f3f3f3" />
          <stop offset="0.73" stop-color="#e9e9e9" />
          <stop offset="0.96" stop-color="#c6c6c6" />
          <stop offset="1" stop-color="#c6c6c6" />
        </linearGradient>
        <linearGradient
          id="Sfumatura_senza_nome_7-3"
          x1="-1350.98"
          y1="1093.03"
          x2="-1345.35"
          y2="1093.03"
          gradientTransform="matrix(0, -42.27, 42.27, 0, -45985.26, -56854.14)"
          xlink:href="#Sfumatura_senza_nome_7"
        />
        <linearGradient
          id="Sfumatura_senza_nome_10-2"
          x1="-1258.74"
          y1="1182.85"
          x2="-1253.11"
          y2="1182.85"
          gradientTransform="matrix(-1.08, 12.34, 12.34, 1.08, -15565.32, 14389.36)"
          xlink:href="#Sfumatura_senza_nome_10"
        />
        <linearGradient
          id="Sfumatura_senza_nome-3"
          x1="-1307.59"
          y1="1034.91"
          x2="-1301.86"
          y2="1034.91"
          gradientTransform="translate(47606.21 59835.38) rotate(90) scale(45.76)"
          xlink:href="#Sfumatura_senza_nome"
        />
        <linearGradient
          id="Sfumatura_senza_nome_10-3"
          x1="-1239.48"
          y1="964.38"
          x2="-1233.84"
          y2="964.38"
          gradientTransform="matrix(1.08, 12.31, -12.31, 1.08, 13481.58, 14361.68)"
          xlink:href="#Sfumatura_senza_nome_10"
        />
      </defs>
      <g id="Livello_2" data-name="Livello 2">
        <g id="layer">
          <path
            d="M12.9,457.5c14.2,0,21.2,7.5,21.2,20.8,0,12.6-7,21-21.9,21H0V457.5Zm15.5,20.8c0-11.1-5.5-16.1-16.5-16.1H5.6v32.5h5.7c12.1,0,17.1-5.3,17.1-16.4"
          />
          <path
            d="M75,464.1a14.22,14.22,0,0,0-8.6-2.7c-6.1,0-9,2.7-9,6.1s2.1,4.6,7.8,7.5c9.8,4.2,14.1,6,14.1,13.1,0,5.5-4.2,11.9-15.2,11.9a26.14,26.14,0,0,1-14.7-4.4l2.6-4.2a21.7,21.7,0,0,0,12.4,3.8c6.3,0,9.4-3.2,9.4-7,0-3.5-2.9-4.8-9.8-7.8-8.7-3.6-12.2-6.2-12.2-12.4,0-5.9,4.4-11.3,14.7-11.3,3.8,0,8.3,1.2,10.9,3.4Z"
          />
          <path
            d="M152.9,499.3h-5.5q-1.8-5.7-3.9-11.7H124.1q-2.1,5.85-3.9,11.7h-5.5a253.77,253.77,0,0,1,16.6-42.1h5c4.8,9,12.7,29.3,16.6,42.1m-11-16.3a142.07,142.07,0,0,0-8.1-19.4c-2.5,4.2-6.3,13.8-8.1,19.4Z"
          />
          <path
            d="M196.8,457.5h5.5v25.9c0,8.5-2.7,16.6-15.8,16.6-5.7,0-10.2-1.6-12.8-5.1s-2.9-7.2-2.9-11.5V457.5h5.5v24.8c0,7.2,1.4,13.1,10.2,13.1,8.6,0,10.2-5.5,10.2-13.1V457.5Z"
          />
          <polygon
            points="239.4 499.3 233.9 499.3 233.9 462.5 221.2 462.5 221.2 457.6 252 457.6 252 462.5 239.4 462.5 239.4 499.3"
          />
          <path
            d="M267.2,478.1c0-12.4,8.2-21.3,20.4-21.3,12,0,20.4,8.7,20.4,21.3,0,11.8-7,21.8-20.4,21.8-12.5.1-20.4-8.9-20.4-21.8m5.7,0c0,9.2,5.2,17,14.7,17,10.1,0,14.7-8.1,14.7-17,0-9.2-5.7-16.5-14.7-16.5-8.8.1-14.7,6.4-14.7,16.5"
          />
          <path
            d="M372.7,457.5v41.8h-5.5V463.4a136.92,136.92,0,0,0-7.5,12,101.23,101.23,0,0,0-5.5,11.9h-5.9a135.85,135.85,0,0,0-13.1-23.9v35.9h-5.5V457.5h7.6a111.62,111.62,0,0,1,8.5,13,93.13,93.13,0,0,1,5.3,10.4A136.26,136.26,0,0,1,365,457.5Z"
          />
          <path
            d="M394.4,478.1c0-12.4,8.2-21.3,20.4-21.3,12,0,20.4,8.7,20.4,21.3,0,11.8-7,21.8-20.4,21.8-12.4.1-20.4-8.9-20.4-21.8m5.7,0c0,9.2,5.2,17,14.7,17,10.1,0,14.7-8.1,14.7-17,0-9.2-5.7-16.5-14.7-16.5-8.7.1-14.7,6.4-14.7,16.5"
          />
          <path
            d="M485.3,487.6a11,11,0,0,1-4.6,9.2c-3.2,2.3-6.4,2.5-11.2,2.5H457V457.5h12.3c8.2,0,12.6,4.4,12.6,10.7a9.85,9.85,0,0,1-5.5,8.9,10.52,10.52,0,0,1,8.9,10.5m-22.8-11.9H468c5.1,0,8.3-1.8,8.3-6.9,0-4.6-3.1-7-8.3-7h-5.5Zm17.1,11.6c0-5.8-4.5-7.2-10.8-7.2h-6.3v15h6.8c7.2,0,10.3-2.8,10.3-7.8"
          />
          <rect x="508.3" y="457.5" width="5.5" height="41.8" />
          <polygon
            points="546 494.5 564.3 494.5 564.3 499.3 540.5 499.3 540.5 457.5 546 457.5 546 494.5"
          />
          <polygon
            points="589.2 462.3 589.2 474.4 603.7 474.4 603.7 479.3 589.2 479.3 589.2 494.6 608.8 494.6 608.8 499.3 583.7 499.3 583.7 457.5 607.4 457.5 607.4 462.3 589.2 462.3"
          />
          <path
            d="M653,464.1a14.22,14.22,0,0,0-8.6-2.7c-6.1,0-9,2.7-9,6.1s2.1,4.6,7.8,7.5c9.8,4.2,14.1,6,14.1,13.1,0,5.5-4.2,11.9-15.2,11.9a26.14,26.14,0,0,1-14.7-4.4l2.6-4.2a21.7,21.7,0,0,0,12.4,3.8c6.3,0,9.4-3.2,9.4-7,0-3.5-2.9-4.8-9.8-7.8-8.7-3.6-12.2-6.2-12.2-12.4,0-5.9,4.4-11.3,14.7-11.3,3.8,0,8.3,1.2,10.9,3.4Z"
          />
          <polygon
            class="ds-1"
            points="330.2 393.9 330.2 395.9 330.2 395.9 330.2 393.9 330.2 393.9"
          />
          <path
            class="ds-2"
            d="M490.3,267c0-3.1-2.3-5.6-3.3-6.6-1.4-1.3-8.2-7.2-8.2-7.2L340.5,145.5c24.1,23.6,58.9,61.9,70.1,95.6a82,82,0,0,1,4.5,25.8,62.49,62.49,0,0,1-4.5,22.4c-5.5,14.3-17.2,31-35,49.7-6.2,6.5-32.4,32.8-41.1,41.5a14.08,14.08,0,0,0-3.7,7.4c0,.2-.1.4-.1.6s-.1.4-.1.6-.1.6-.1.9a1.27,1.27,0,0,1-.1.6c0,.3-.1.7-.1,1.1v.5c0,.6-.1,1.1-.1,1.7v2L485.3,275.1C486.8,274,490.3,271,490.3,267Z"
          />
          <path
            class="ds-3"
            d="M484.1,270.3c-.3-1.2-1.4-1.6-3.7-1.6a.37.37,0,0,0-.3.1c-6.1.1-18.6,1-29.2,2-9.9,1-12.2,5.2-17,15.6-17.1,37-47.7,58.6-46.7,59.6.5.6,19.9-14,22-15.6,32.6-26,56.3-45.1,72.4-56.5C483.5,272.6,484.4,271.3,484.1,270.3Z"
          />
          <path class="ds-1" d="M489.9,3h0V3Z" />
          <path
            class="ds-4"
            d="M334.8,123.7a14.12,14.12,0,0,0-4.6,5.7,7.8,7.8,0,0,0,0,4.8,11.93,11.93,0,0,0,2.9,4.2c1.1,1.1,7.8,6.7,7.8,6.7L478.8,252.5c-24-23.6-58.2-61.5-69.2-94.8a82,82,0,0,1-4.5-25.8,62.49,62.49,0,0,1,4.5-22.4c5.5-14.3,17.3-31,35-49.7,5.7-6,29.2-29.5,41.1-41.4a13.35,13.35,0,0,0,3.7-7.6A30.71,30.71,0,0,0,489.9,5V3Z"
          />
          <path
            d="M402.1,155.6a71.82,71.82,0,0,1-4.1-23.8c0-7.2,2-14.5,5-21.7,12.7-30.8,72-83.7,84.1-93.4,0-.1.1-.1.1-.2-10.6,7.6-54.3,45.4-65.8,56.8-18.6,18.4-32.8,38.7-32.8,58.6,0,21.8,15.2,44,32.4,64.3a375.08,375.08,0,0,0,31.6,33.6c10.9,10,18.3,16.7,26.1,22.8-8.9-8.1-62.4-56.1-76.6-97"
          />
          <path
            class="ds-1"
            d="M397.9,131.8c0,1.19,0,2.39.1,3.59v-6.34C397.94,130,397.9,130.89,397.9,131.8Z"
          />
          <path
            class="ds-5"
            d="M478.6,252.3c-24-23.6-58.1-61.4-69.1-94.7a82,82,0,0,1-4.5-25.8,62.49,62.49,0,0,1,4.5-22.4c5.5-14.3,17.3-31,35-49.7,5.7-6,29.2-29.5,41.1-41.4a10.7,10.7,0,0,0,1.4-1.6c-12.1,9.7-71.4,62.5-84.1,93.4a61.8,61.8,0,0,0-4.9,19v6.34a70.92,70.92,0,0,0,4,20.21C416.2,196.2,469.2,243.9,478.6,252.3Z"
          />
          <path
            class="ds-1"
            d="M422.3,267.1c0-1.19,0-2.39-.1-3.59v6.34C422.26,268.93,422.3,268,422.3,267.1Z"
          />
          <path
            class="ds-1"
            d="M333.2,382.2l.12-.1h-.05S333.22,382.16,333.2,382.2Z"
          />
          <path
            class="ds-6"
            d="M417.3,288.8a61.8,61.8,0,0,0,4.9-18.95v-6.34a71,71,0,0,0-4-20.21c-14.4-41-68.7-89.7-77.6-97.7,24.1,23.6,58.9,61.9,70,95.6a82,82,0,0,1,4.5,25.8,62.49,62.49,0,0,1-4.5,22.4c-5.5,14.3-17.2,31-35,49.7-6.2,6.5-32.4,32.8-41.1,41.5a10.45,10.45,0,0,0-1.23,1.5h.05C345.78,372.06,404.64,319.5,417.3,288.8Z"
          />
          <path
            d="M399.1,202.7a375.08,375.08,0,0,0-31.6-33.6c-10.9-10-19.1-17.4-26.9-23.5,8.9,8,63.3,56.7,77.5,97.6a71.82,71.82,0,0,1,4.1,23.8c0,7.2-2,14.5-5,21.7-12.7,30.8-71.9,83.6-84.1,93.4,0,.1-.1.1-.1.2,10.7-7.7,54.3-45.4,65.7-56.7,18.6-18.4,32.8-38.7,32.8-58.6,0-21.8-15.1-44-32.4-64.3"
          />
          <path
            d="M271.6,131.8c0,21.5-14.9,43.5-34.3,63.4a411.36,411.36,0,0,1-36.8,33.2c-12.3,9.9-21.7,16.5-30.5,22.4,10.1-7.9,71.3-55.2,87.3-95.5,3.1-7.9,5-15.8,5-23.5a62,62,0,0,0-5-23.5C241.2,68,180,20.7,170,12.8c8.8,6,18.2,12.6,30.5,22.4a411.36,411.36,0,0,1,36.8,33.2c19.4,19.9,34.3,41.9,34.3,63.4"
          />
          <polygon
            class="ds-1"
            points="167.5 252.8 167.51 252.79 167.5 252.78 167.5 252.8"
          />
          <polygon
            class="ds-1"
            points="167.5 10.8 167.5 10.85 167.54 10.83 167.5 10.8"
          />
          <path
            class="ds-7"
            d="M250.6,155.4a68.57,68.57,0,0,0,4.6-23.5,67.67,67.67,0,0,0-4.6-23.5C235.8,68.1,179.3,20.8,170,12.9l-2.46-2.07,0,0V252.78h0L170,250.9C179.3,243,235.8,195.7,250.6,155.4Z"
          />
          <path
            class="ds-8"
            d="M170,12.7c9.3,7.9,65.8,55.2,80.6,95.5a68.57,68.57,0,0,1,4.6,23.5,67.67,67.67,0,0,1-4.6,23.5c-14.8,40.3-71.3,87.6-80.6,95.5,10.1-7.9,71.3-55.2,87.3-95.5,3.1-7.9,5-15.8,5-23.5a62,62,0,0,0-5-23.5C241.2,68,180,20.6,170,12.7Z"
          />
          <path
            d="M488,259.4c-11.4-10.8-63.2-60-77.1-102.2a81.28,81.28,0,0,1-4.4-25.4,61.51,61.51,0,0,1,4.4-21.9c6.3-16.5,20.4-34.2,34.7-49.2,6.1-6.4,32.5-32.8,41.2-41.5a14.93,14.93,0,0,0,3.9-7.3,38.39,38.39,0,0,0,.7-7l.1-4.9L334,122.6c-1.7,1.3-4.3,3.7-5.3,6.8-.9-3.2-3.6-5.6-5.2-6.8L166.1,0V263.7L323.5,141.1c1.7-1.3,4.3-3.7,5.2-6.9a11.72,11.72,0,0,0,3.4,5.2c11.4,10.8,63.2,60,77.1,102.2a81.28,81.28,0,0,1,4.4,25.4,61.51,61.51,0,0,1-4.4,21.9c-6.3,16.5-20.4,34.2-34.7,49.2-6.1,6.4-32.5,32.9-41.2,41.6a15.33,15.33,0,0,0-3.9,7.3,36,36,0,0,0-.7,7l-.1,4.9L486.1,276.2c2.2-1.6,5.6-4.9,5.6-9.2,0-3.8-2.9-6.8-3.7-7.6M322.6,139.9,167.5,260.8V3L322.6,123.8c1.9,1.4,5,4.4,5,8.1s-3.1,6.6-5,8m7.6-5.7a7.8,7.8,0,0,1,0-4.8,14.12,14.12,0,0,1,4.6-5.7L489.9,2.9v2a45.09,45.09,0,0,1-.5,5.8,14,14,0,0,1-3.7,7.6c-11.9,11.9-35.4,35.4-41.1,41.5-17.7,18.7-29.5,35.4-35,49.7a62.49,62.49,0,0,0-4.5,22.4,81.08,81.08,0,0,0,4.5,25.8c11,33.4,45.2,71.2,69.2,94.8L340.9,145.1s-6.7-5.6-7.8-6.7a13.41,13.41,0,0,1-2.9-4.2M485.3,275.1,330.2,395.9v-2a33.88,33.88,0,0,1,.5-5.8,14.72,14.72,0,0,1,3.7-7.6c8.7-8.7,35-35,41.1-41.5,17.7-18.6,29.5-35.4,35-49.7a62.49,62.49,0,0,0,4.5-22.4,81.08,81.08,0,0,0-4.5-25.8c-11.1-33.7-46-72-70-95.6L478.8,253.2s6.8,5.9,8.2,7.2c1,.9,3.3,3.5,3.3,6.6,0,3.9-3.5,6.9-5,8.1"
          />
          <path
            class="ds-9"
            d="M412.6,193c-17.7-16.6-32-42.1-32.1-42.3-5.3-10.2-7.1-14.7-17-15.6-10.6-1-17.4-1.3-23.5-1.4a.37.37,0,0,0-.3-.1c-2.3,0-3.3.4-3.7,1.6-.3,1,.6,2.3,2.5,3.6,16.1,11.4,39.8,30.5,72.4,56.5,2.1,1.6,18.8,16.1,19.3,15.6C430.6,210.6,414.6,194.9,412.6,193Z"
          />
          <polygon
            class="ds-1"
            points="167.5 260.8 172.89 256.6 167.5 256.6 167.5 260.8"
          />
          <path
            class="ds-10"
            d="M322.6,123.8,167.5,3v7.9l2.5,1.9c8.8,6,18.2,12.5,30.5,22.4a411.36,411.36,0,0,1,36.8,33.2c19.4,20,34.3,41.9,34.3,63.4s-14.9,43.5-34.3,63.4a411.36,411.36,0,0,1-36.8,33.2c-12.3,9.9-21.6,16.4-30.4,22.4a.1.1,0,0,0-.1.1l-2.5,1.9v8L322.6,140c1.9-1.4,5-4.4,5-8.1S324.5,125.2,322.6,123.8Z"
          />
          <path
            class="ds-11"
            d="M321.4,135.1c-.3-1.2-1.4-1.6-3.7-1.6a.37.37,0,0,1-.3.1c-6.1.1-12.9.4-23.5,1.4-9.9,1-11.7,5.4-17,15.6-.1.3-14.4,25.7-32.1,42.3-2,1.9-4,3.8-6.1,5.7-9.3,8.3-13.4,12.1-13.3,12.2.6.5,5.3-3.7,14.8-10.7,2.2-1.6,4.3-3.3,6.3-4.9,32.9-25.5,56.3-45.1,72.4-56.5C320.7,137.4,321.6,136.1,321.4,135.1Z"
          />
        </g>
      </g>
    </svg>
    <!-- Citroen Logo -->
    <svg
      id="logo-citroen"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 717.07 505.4"
      aria-labelledby="titleLogoCitroen contentLogoCitroen"
      role="img"
    >
      <title
        v-if="getString('icon-logo-citroen', 'title')"
        id="titleLogoCitroen"
      >
        {{ getString('icon-logo-citroen', 'title') }}
      </title>
      <desc id="contentLogoCitroen">
        {{ getString('icon-logo-citroen', 'description') }}
      </desc>
      <g>
        <g>
          <path
            fill="currentColor"
            d="M554.04,304.38c-5.91-6.51-145.01-159.1-195.36-159.1c-50.34,0-189.45,152.59-195.35,159.09l-0.01,0.01
            c-0.58,0.64-14.16,16.07-14.16,34.05c0,14,0.94,28.09,0.95,28.23c0.03,0.65,0.36,6.6,3.68,8.22c0.54,0.27,1.12,0.4,1.72,0.4
            c1.24,0,2.61-0.55,4.11-1.64c1.5-1.32,143.21-125.7,199.05-125.7c55.85,0,197.56,124.39,198.98,125.64
            c1.54,1.13,2.94,1.69,4.19,1.69c0.6,0,1.18-0.13,1.72-0.39c3.32-1.62,3.65-7.57,3.67-8.25c0.01-0.11,0.94-14.2,0.94-28.2
            C568.2,320.44,554.62,305.02,554.04,304.38z M555.54,355.51c-36.58-31.17-145.26-119.86-196.85-119.86
            c-51.62,0-160.22,88.64-196.81,119.83c-0.22-7.37-0.42-11.85-0.42-18.41c0,0-0.89-10.84,8.75-21.68
            c79.35-71.45,162.54-106.41,165.09-107.48c24.81-10.42,23.41-8.46,23.39-50.28c0,0,1.1-0.07,1.81,0.01
            c34.93,3.14,128.86,93.74,184.45,154.98c0.1,0.11,10.97,12.61,10.97,25.8C555.92,344.6,555.74,350.69,555.54,355.51z"
          />
          <g>
            <path
              fill="currentColor"
              d="M466.09,439.24c-17.62-0.39-35.52-0.01-35.67,0c-21.52,0-39.02,14.92-39.02,33.26
                c0,18.61,17.51,33.75,39.04,33.75c0.14,0,18.04,0.36,35.67,0c21.56,0,39.1-15.14,39.1-33.75
                C505.2,454.34,488.02,439.73,466.09,439.24z M454.01,497.05h-0.06c-1.41,0.04-6.37,0.17-11.23,0c-12.39,0-25.76-9.34-25.76-24.45
                c0-14.97,13.1-23.93,25.7-23.92c0.16-0.03,6.3-0.29,11.36-0.01c12.66,0,25.77,8.95,25.77,23.93
                C479.78,487.7,466.4,497.05,454.01,497.05z"
            />
            <path
              fill="currentColor"
              d="M695.12,505.4c0,0,21.11,0,21.94,0c0-0.85-0.01-31.94-0.01-31.94c0-18.65-16.71-33.27-38.03-33.27
                l-55.51-0.01c-0.91,0-3.02,0.23-3.02,2.44l0.01,60.31c0,1.62,1.17,2.47,2.33,2.47c0,0,22.37,0.01,23.2,0.01
                c0-0.86-0.01-50.45-0.01-50.45c0-2.22,1.67-3.38,3.32-3.38l25.57-0.01c7.07,0,17.54,6.45,17.54,20.28l0,31.03
                C692.45,502.88,692.51,505.4,695.12,505.4z"
            />
            <path
              fill="currentColor"
              d="M232.01,453.12c0,0,33.39,0.01,34.24,0.01c0-0.8,0-10.39,0-10.39c0-1.46-1.05-2.56-2.46-2.56h-95.44
                c-1.55,0-2.49,1.28-2.49,2.52c0,0,0,9.62,0,10.42c0.84,0,22.81,0.01,22.81,0.01c8.56,0,14.31,7.34,14.31,14.19v35.6
                c0,1.18,1.04,2.48,2.52,2.48c0,0,22.3,0.01,23.14,0.01c0-0.86,0-48.95,0-48.95C228.66,454.62,230.17,453.12,232.01,453.12z"
            />
            <path
              fill="currentColor"
              d="M126.5,502.92c0,1.46,1.33,2.49,2.52,2.49h1.31c0,0-0.1,0.08-0.18,0.16c0.66-0.16,2.89-0.16,10.67-0.16
                c0,0,10.52-0.01,11.33-0.01c0-0.86,0-62.74,0-62.74c0-1.34-1.12-2.49-2.46-2.49h-20.67c-1.36,0-2.51,1.14-2.51,2.48L126.5,502.92
                z"
            />
            <path
              fill="currentColor"
              d="M355.33,505.41h25.46c-0.4-15.67-16.72-22.17-18.6-22.86l-0.33-0.12l0.02-0.89l0.33-0.07
                c10.91-2.44,18.52-10.78,18.52-20.29c0-10.1-9.89-21.01-25.87-21.01l-61.58,0.01c-7.46,0-13.31,5.85-13.31,13.31v49.42
                c0,1.43,1.03,2.46,2.45,2.46c0,0,22.26,0.02,23.11,0.02c0-0.84-0.02-23.13-0.02-23.13h21.83
                C346.76,482.27,354.74,496.29,355.33,505.41z M305.53,470.72v-13.02c0-3.56,2.53-6.05,6.16-6.05h34.06
                c5.16,0,9.53,4.34,9.53,9.47c0,5.29-4.32,9.6-9.64,9.6H305.53z"
            />
            <path
              fill="currentColor"
              d="M87.61,462.07c0,0,23.61,0,24.92,0c-5.4-13.63-20.35-22.99-37.53-23.33l-7.66-0.15
                c-12-0.26-17.48-0.37-27.99,0.15c-12.28,0.62-20.01,3.42-27.58,10.01c-7.38,6.44-11.46,14.94-11.47,23.97
                c0,18.65,16.59,33.29,38.6,34.05c15.08,0.54,16.69,0.55,36.47-0.04c18.32-0.55,31.47-8.85,37.13-23.32c-1.29,0-24.91,0-24.91,0
                c-0.94,0-1.66,0.41-2.14,1.24c-4.51,7.77-13.15,12.6-22.53,12.6l0,0c-5.12,0.21-11.31,0-11.31,0c-12.66,0-25.77-9.14-25.77-24.43
                l0.01-0.14c0.08-15.2,13.16-24.29,25.82-24.29c1.45-0.06,6.55-0.23,11.23,0c9.24,0,18.1,4.9,22.58,12.47
                C85.66,461.15,86.29,462.07,87.61,462.07z"
            />
            <path
              fill="currentColor"
              d="M606.77,493.68c-0.86,0-60.33,0-60.33,0c-2.03,0-3.46-1.35-3.46-3.28v-12.43c0,0,51.43,0,52.29,0
                c0-0.78,0-10.66,0-11.45c-0.86,0-52.29,0-52.29,0l-0.03-11.35c0-0.05-0.04-1.27,0.89-2.23c0.69-0.71,1.7-1.07,3.01-1.07
                c0,0,59.05,0,59.91,0c0-0.79,0-9.15,0-9.15c0-0.78-0.22-1.39-0.67-1.82c-0.83-0.79-2.19-0.74-2.27-0.74h-83.91
                c-0.26,0-2.55,0.07-2.55,2.56l0.01,49.39c0,6.53,5.02,13.27,13.42,13.27l73.49,0c0.61,0,1.24-0.26,1.72-0.72
                c0.5-0.47,0.78-1.09,0.78-1.71C606.77,502.97,606.77,494.48,606.77,493.68z"
            />
            <path
              fill="currentColor"
              d="M588.01,416.59c-2.45-1.52-5.41-2.27-8.88-2.27c-3.46,0-6.53,0.8-8.88,2.27c-2.34,1.46-4.22,3.42-6.99,3.42
                c-2.77,0-4.43-1.96-6.93-3.42c-2.5-1.47-5.42-2.27-8.88-2.27c-3.47,0-6.41,0.75-8.88,2.27c-2.45,1.49-3.68,3.31-3.68,5.41
                c0,2.13,1.24,3.93,3.68,5.43c2.47,1.51,5.42,2.25,8.88,2.25c3.45,0,6.46-0.72,8.69-2.07c2.22-1.35,4.62-3.56,7.12-3.56
                c2.51,0,4.77,1.98,7,3.39c2.23,1.4,5.43,2.24,8.88,2.24c3.57,0,6.56-0.74,8.96-2.25c2.4-1.49,3.6-3.3,3.6-5.43
                C591.69,419.9,590.46,418.08,588.01,416.59z"
            />
          </g>
          <path
            fill="currentColor"
            d="M553.85,159.3c-5.9-6.5-144.86-158.94-195.16-158.94c-50.29,0-189.26,152.44-195.15,158.93l-0.01,0.01
            c-0.58,0.64-14.14,16.05-14.14,34.02c0,13.98,0.94,28.06,0.95,28.2c0.03,0.65,0.36,6.59,3.68,8.21c0.54,0.26,1.12,0.4,1.72,0.4
            c1.24,0,2.61-0.55,4.11-1.63c1.49-1.32,143.06-125.58,198.85-125.58c55.79,0,197.36,124.26,198.78,125.52
            c1.54,1.13,2.94,1.69,4.19,1.69c0.6,0,1.18-0.13,1.72-0.39c3.32-1.61,3.64-7.56,3.67-8.24c0.01-0.11,0.94-14.18,0.94-28.17
            C567.98,175.35,554.42,159.94,553.85,159.3z M555.34,210.37C518.8,179.24,410.22,90.63,358.69,90.63
            c-51.56,0-160.06,88.55-196.62,119.71c-0.22-7.36-0.42-11.84-0.42-18.38c0,0-0.89-10.83,8.74-21.66
            C249.66,98.92,332.77,64,335.32,62.93c24.78-10.41,23.39-8.46,23.37-50.23c0,0,1.1-0.07,1.81,0
            c34.9,3.14,128.73,93.65,184.26,154.83c0.1,0.11,10.96,12.6,10.96,25.78C555.73,199.48,555.54,205.57,555.34,210.37z"
          />
        </g>
      </g>
    </svg>

    <!-- Hamburger circle -->
    <svg
      id="icon-hamburger-circle"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.07 29.07"
      aria-labelledby="titleHamburgerCircle contentHamburgerCircle"
      role="img"
    >
      <title
        v-if="getString('icon-hamburger-circle', 'title')"
        id="titleHamburgerCircle"
      >
        {{ getString('icon-hamburger-circle', 'title') }}
      </title>
      <desc id="contentHamburgerCircle">
        {{ getString('icon-hamburger-circle', 'description') }}
      </desc>
      <path
        d="M20.21,10.64H8.86a1.07,1.07,0,0,1,0-2.13H20.21a1.07,1.07,0,0,1,0,2.13Z"
      />
      <path
        d="M20.21,15.6H8.86a1.07,1.07,0,0,1,0-2.13H20.21a1.07,1.07,0,0,1,0,2.13Z"
      />
      <path
        d="M20.21,20.56H8.86a1.06,1.06,0,0,1,0-2.12H20.21a1.06,1.06,0,0,1,0,2.12Z"
      />
      <path
        d="M14.54,29.07a14.53,14.53,0,1,1,10.28-4.26A14.53,14.53,0,0,1,14.54,29.07Zm0-26.94a12.41,12.41,0,1,0,8.77,3.63A12.4,12.4,0,0,0,14.54,2.13Z"
      />
    </svg>
    <!-- Info circle -->
    <svg
      id="icon-info"
      viewBox="0 0 19.475 19.475"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleInfo contentInfo"
      role="img"
    >
      <title v-if="getString('icon-info', 'title')" id="titleInfo">
        {{ getString('icon-info', 'title') }}
      </title>
      <desc id="contentInfo">
        {{ getString('icon-info', 'description') }}
      </desc>
      <path
        d="M17.515,3.9a9.714,9.714,0,1,1-2.29-2.2l-.013.017a.854.854,0,0,1,.368.692.873.873,0,0,1-.872.874.858.858,0,0,1-.574-.225l-.006.007A7.991,7.991,0,1,0,17.75,9.737a7.943,7.943,0,0,0-1.628-4.822l.01-.007a.853.853,0,0,1-.171-.49.862.862,0,0,1,.862-.862.844.844,0,0,1,.679.355ZM10.6,6.047v4.8a.862.862,0,1,1-1.724,0v-4.8a.862.862,0,1,1,1.724,0Zm-.862,6.52a.862.862,0,1,1-.862.862A.862.862,0,0,1,9.737,12.566Z"
        transform="translate(19.475 19.475) rotate(180)"
      />
    </svg>
    <svg
      id="icon-check"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleCheck contentCheck"
      role="img"
      viewBox="0 0 448 512"
    >
      <title v-if="getString('icon-check', 'title')" id="titleCheck">
        {{ getString('icon-check', 'title') }}
      </title>
      <desc id="contentCheck">
        {{ getString('icon-check', 'description') }}
      </desc>
      <path
        fill="currentColor"
        d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
      />
    </svg>
    <svg
      id="icon-filters"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="titleFilters contentFilters"
      role="img"
      viewBox="0 0 512 512"
    >
      <title v-if="getString('icon-filters', 'title')" id="titleFilters">
        {{ getString('icon-filters', 'title') }}
      </title>
      <desc id="contentFilters">
        {{ getString('icon-filters', 'description') }}
      </desc>
      <path
        fill="currentColor"
        d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SvgIconsCmp',
  computed: {
    currentBrandData() {
      return this.$context.brands.find((b) => b.id === this.currentBrand);
    },
    currentBrand() {
      return this.$context.currentBrand;
    },
  },
  mounted() {
    if (
      this.$el.querySelectorAll(`#${this.currentBrandData?.svgLogoId}`).length
    ) {
      this.$store.dispatch('setSvgBrandLogo', true);
    } else {
      this.$store.dispatch('setSvgBrandLogo', false);
    }
  },
  methods: {
    getString(id, attribute) {
      if (this.$store && this.$store.state.icons) {
        return this.$store.state.icons[id]
          ? this.$store.state.icons[id][attribute]
            ? this.$store.state.icons[id][attribute]
            : ''
          : '';
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.SvgIconsCmp {
  position: fixed;
  right: -9999px;
  bottom: -9999px;
  width: 0;
  height: 0;
  visibility: hidden;

  svg {
    visibility: visible;
  }

  .ds-1 {
    fill: none;
  }

  .ds-2 {
    fill: url(#Sfumatura_senza_nome);
  }

  .ds-3 {
    fill: url(#Sfumatura_senza_nome_10);
  }

  .ds-4 {
    fill: url(#Sfumatura_senza_nome-2);
  }

  .ds-5 {
    fill: url(#Sfumatura_senza_nome_7);
  }

  .ds-6 {
    fill: url(#Sfumatura_senza_nome_7-2);
  }

  .ds-7 {
    fill: url(#Sfumatura_senza_nome_6);
  }

  .ds-8 {
    fill: url(#Sfumatura_senza_nome_7-3);
  }

  .ds-9 {
    fill: url(#Sfumatura_senza_nome_10-2);
  }

  .ds-10 {
    fill: url(#Sfumatura_senza_nome-3);
  }

  .ds-11 {
    fill: url(#Sfumatura_senza_nome_10-3);
  }
}
</style>
